
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirebf3b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirebf3b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("47uWi", function(module, exports) {

$parcel$export(module.exports, "FlowComponent", () => $2fffd0c62edf8d53$export$608bd20f689d20a6);
class $2fffd0c62edf8d53$export$608bd20f689d20a6 extends HTMLElement {
    _root;
    _bindings = new Map;
    _abort = new AbortController;
    constructor(){
        if (super(), new.target === $2fffd0c62edf8d53$export$608bd20f689d20a6) throw new TypeError("FlowComponent is an abstract class and cannot be instantiated directly.");
        this._root = this.attachShadow({
            mode: "open"
        });
    }
    static get template() {
        return null;
    }
    static get styles() {
        return [];
    }
    static html(t, ...n) {
        let e = "";
        const o = new Set;
        for(let i = 0; i < t.length; i++)if (e += t[i], i < n.length) {
            const d = n[i];
            typeof d == "string" ? (e += `{{${d}}}`, o.add(d)) : e += d;
        }
        const r = document.createElement("div");
        r.innerHTML = e;
        const a = new Map;
        function s(i, d) {
            const g = [];
            let c = i;
            for(; c && c !== d;){
                const h = c.parentNode;
                if (!h) break;
                const f = Array.from(h.childNodes).indexOf(c);
                g.unshift(f), c = h;
            }
            return g;
        }
        function l(i, d) {
            a.has(i) || a.set(i, []), a.get(i).push(d);
        }
        r.querySelectorAll("*").forEach((i)=>{
            const d = s(i, r), g = [];
            Array.from(i.attributes).forEach((c)=>{
                const h = [
                    ...c.value.matchAll(/{{(.*?)}}/g)
                ];
                if (h.length === 0) return;
                const f = [];
                let m = c.value;
                h.forEach((y)=>{
                    const w = y[1].trim();
                    f.push(w), o.add(w), m = m.replace(y[0], "");
                });
                const _ = c.value === `{{${f[0]}}}` && f.length === 1, S = {
                    type: "attr",
                    path: [
                        ...d
                    ],
                    attrName: c.name,
                    template: _ ? null : m,
                    vars: f
                };
                f.forEach((y)=>{
                    l(y, S);
                }), g.push(c.name);
            }), g.forEach((c)=>i.removeAttribute(c));
        });
        const u = document.createTreeWalker(r, NodeFilter.SHOW_TEXT), b = [];
        for(; u.nextNode();){
            const i = u.currentNode;
            i.nodeValue.includes("{{") && b.push(i);
        }
        b.forEach((i)=>{
            const d = i.parentNode, g = i.nodeValue.split(/({{.*?}})/g);
            let c = 0;
            g.forEach((h)=>{
                const f = h.match(/{{(.*?)}}/);
                if (f) {
                    const m = f[1].trim();
                    o.add(m);
                    const _ = document.createTextNode("");
                    d.insertBefore(_, i);
                    const S = s(_, r);
                    l(m, {
                        type: "text",
                        path: [
                            ...S
                        ],
                        varName: m
                    }), c++;
                } else h.length > 0 && (d.insertBefore(document.createTextNode(h), i), c++);
            }), d.removeChild(i);
        });
        const p = document.createElement("template");
        for(; r.firstChild;)p.content.appendChild(r.firstChild);
        return p.vars = [
            ...o
        ], p.bindingMap = a, p;
    }
    static get observedAttributes() {
        const t = this.template;
        return t && t.vars ? t.vars : [];
    }
    connectedCallback() {
        this._abort.signal.aborted && (this._abort = new AbortController);
        const t = this._root.childNodes.length > 0, n = this._bindings.size > 0;
        if (t && n) {
            this.onMount();
            return;
        }
        const e = this.constructor;
        if (t && !n) {
            e.template?.bindingMap && (this._connectBindings(this._root, e.template.bindingMap), e.template.vars && e.template.vars.forEach((a)=>{
                const s = this.getAttribute(a);
                s !== null && this._update(a, s);
            })), this.onMount();
            return;
        }
        const { styles: o, template: r } = e;
        if (o) {
            if (!e._processedStyles) {
                const a = Array.isArray(o) ? o.flat(1 / 0) : [
                    o
                ];
                e._processedStyles = a.map((s)=>{
                    if (s instanceof CSSStyleSheet) return s;
                    if (typeof s == "string") try {
                        const l = new CSSStyleSheet;
                        return l.replaceSync(s), l;
                    } catch  {
                        const u = document.createElement("style");
                        return u.textContent = s, u;
                    }
                    return null;
                }).filter(Boolean);
            }
            e._processedStyles.length && (this._root.adoptedStyleSheets && e._processedStyles[0] instanceof CSSStyleSheet ? this._root.adoptedStyleSheets = e._processedStyles : e._processedStyles.forEach((a)=>{
                a instanceof Node && this._root.appendChild(a.cloneNode(!0));
            }));
        }
        if (r) {
            const a = r.content.cloneNode(!0);
            this._connectBindings(a, r.bindingMap), this._root.appendChild(a);
        }
        this.onMount();
    }
    _connectBindings(t, n) {
        function e(r, a) {
            let s = r;
            for (const l of a)if (s = s.childNodes[l], !s) return null;
            return s;
        }
        const o = new Set;
        n.forEach((r, a)=>{
            r.forEach((s)=>{
                const l = e(t, s.path);
                if (l) {
                    if (s.type === "text") {
                        this._addBinding(a, l);
                        const u = this.getAttribute(a);
                        l.nodeValue = u ?? "";
                    } else if (s.type === "attr") {
                        const u = `${s.path.join(",")}-${s.attrName}`;
                        o.has(u) || (this._addBinding(a, l, s.attrName, s.template, s.vars), this._updateAttribute(l, s.attrName, s.template, s.vars), o.add(u));
                    }
                }
            });
        });
    }
    attributeChangedCallback(t, n, e) {
        n !== e && (this._bindings.has(t) && this._update(t, e), this.onAttributeChanged(t, n, e));
    }
    disconnectedCallback() {
        this._abort.abort(), this._bindings.clear(), this.onUnmount();
    }
    _addBinding(t, n, e = null, o = null, r = null) {
        this._bindings.has(t) || this._bindings.set(t, []), this._bindings.get(t).push({
            target: n,
            prop: e,
            template: o,
            vars: r
        });
    }
    _update(t, n) {
        const e = this._bindings.get(t);
        e && e.forEach((o)=>{
            o.target.nodeType === Node.TEXT_NODE ? o.target.nodeValue = n ?? "" : this._updateAttribute(o.target, o.prop, o.template, o.vars);
        });
    }
    _isDangerousValue(t, n, e) {
        if (![
            "href",
            "src",
            "action",
            "formaction",
            "data",
            "poster",
            "background",
            "style",
            "srcdoc",
            "innerHTML"
        ].includes(t) && !t.startsWith("on") || !n) return !1;
        const o = n.trim(), r = o.toLowerCase();
        if ([
            "javascript:",
            "vbscript:",
            "file:"
        ].some((l)=>r.startsWith(l)) || /&#0*106;&#0*97;&#0*118;/i.test(n) || /\\x6a\\x61\\x76/i.test(n)) return !0;
        if ([
            "href",
            "src",
            "action",
            "formaction",
            "data",
            "poster",
            "background"
        ].includes(t)) {
            if (/^[a-z][a-z0-9+.-]*:/i.test(o) && !/^(https?|mailto|tel|sms|ftp|ftps):/i.test(o)) return !0;
            if (r.startsWith("data:")) return !/^data:image\/(png|jpe?g|gif|webp|svg\+xml);base64,/i.test(o);
        }
        return !!(t === "style" && /expression|javascript|@import|behavior/i.test(n));
    }
    _updateAttribute(t, n, e, o) {
        let r;
        if (e) {
            const l = e.split("");
            r = l.reduce((u, b, p)=>{
                if (p === l.length - 1) return u + b;
                const i = this.getAttribute(o[p]) ?? "";
                return u + b + i;
            }, "").trim();
        } else r = this.getAttribute(o[0]) ?? "";
        if (this._isDangerousValue(n, r, t)) {
            console.warn(`[FlowComponent] Blocked potentially dangerous value for attribute "${n}":`, r);
            return;
        }
        const s = [
            "style",
            "innerHTML",
            "outerHTML",
            "textContent",
            "srcdoc"
        ].includes(n) || n.startsWith("on");
        n in t && !s ? t[n] = r : t.setAttribute(n, r);
    }
    get root() {
        return this._root;
    }
    get signal() {
        return this._abort.signal;
    }
    emit(t, n = {}) {
        this.dispatchEvent(new CustomEvent(t, {
            detail: n,
            bubbles: !0,
            composed: !0
        }));
    }
    onMount() {}
    onUnmount() {}
    onAttributeChanged(t, n, e) {}
}

});

parcelRegister("kaZmj", function(module, exports) {

$parcel$export(module.exports, "tailwindSheet", () => $eb0456654519ace3$export$7fe0e364ef551466);
$parcel$export(module.exports, "baseStyles", () => $eb0456654519ace3$export$6a08aa478781aaec);
/**
 * Estilos globales de Tailwind capturados por Parcel
 * e inyectados en una CSSStyleSheet compartida.
 */ 
var $155l4 = parcelRequire("155l4");
const $eb0456654519ace3$export$7fe0e364ef551466 = new CSSStyleSheet();
$eb0456654519ace3$export$7fe0e364ef551466.replaceSync($155l4.default || $155l4);
// Estilos base adicionales si los necesitamos
const $eb0456654519ace3$export$6a08aa478781aaec = new CSSStyleSheet();
$eb0456654519ace3$export$6a08aa478781aaec.replaceSync(`
    :host {
        box-sizing: border-box;
    }
`);

});
parcelRegister("155l4", function(module, exports) {
module.exports = "/*! tailwindcss v4.1.14 | MIT License | https://tailwindcss.com */\n@layer properties{@supports (((-webkit-hyphens:none)) and (not (margin-trim:inline))) or ((-moz-orient:inline) and (not (color:rgb(from red r g b)))){*,:before,:after,::backdrop{--tw-translate-x:0;--tw-translate-y:0;--tw-translate-z:0;--tw-rotate-x:initial;--tw-rotate-y:initial;--tw-rotate-z:initial;--tw-skew-x:initial;--tw-skew-y:initial;--tw-space-y-reverse:0;--tw-divide-x-reverse:0;--tw-border-style:solid;--tw-divide-y-reverse:0;--tw-gradient-position:initial;--tw-gradient-from:#0000;--tw-gradient-via:#0000;--tw-gradient-to:#0000;--tw-gradient-stops:initial;--tw-gradient-via-stops:initial;--tw-gradient-from-position:0%;--tw-gradient-via-position:50%;--tw-gradient-to-position:100%;--tw-leading:initial;--tw-font-weight:initial;--tw-tracking:initial;--tw-shadow:0 0 #0000;--tw-shadow-color:initial;--tw-shadow-alpha:100%;--tw-inset-shadow:0 0 #0000;--tw-inset-shadow-color:initial;--tw-inset-shadow-alpha:100%;--tw-ring-color:initial;--tw-ring-shadow:0 0 #0000;--tw-inset-ring-color:initial;--tw-inset-ring-shadow:0 0 #0000;--tw-ring-inset:initial;--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-offset-shadow:0 0 #0000;--tw-outline-style:solid;--tw-blur:initial;--tw-brightness:initial;--tw-contrast:initial;--tw-grayscale:initial;--tw-hue-rotate:initial;--tw-invert:initial;--tw-opacity:initial;--tw-saturate:initial;--tw-sepia:initial;--tw-drop-shadow:initial;--tw-drop-shadow-color:initial;--tw-drop-shadow-alpha:100%;--tw-drop-shadow-size:initial;--tw-backdrop-blur:initial;--tw-backdrop-brightness:initial;--tw-backdrop-contrast:initial;--tw-backdrop-grayscale:initial;--tw-backdrop-hue-rotate:initial;--tw-backdrop-invert:initial;--tw-backdrop-opacity:initial;--tw-backdrop-saturate:initial;--tw-backdrop-sepia:initial;--tw-duration:initial;--tw-ease:initial;--tw-scale-x:1;--tw-scale-y:1;--tw-scale-z:1}}}@layer theme{:root,:host{--font-sans:ui-sans-serif,system-ui,sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";--font-mono:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace;--color-red-50:oklch(97.1% .013 17.38);--color-red-100:oklch(93.6% .032 17.717);--color-red-200:oklch(88.5% .062 18.334);--color-red-500:oklch(63.7% .237 25.331);--color-red-600:oklch(57.7% .245 27.325);--color-red-700:oklch(50.5% .213 27.518);--color-red-800:oklch(44.4% .177 26.899);--color-red-900:oklch(39.6% .141 25.723);--color-orange-500:oklch(70.5% .213 47.604);--color-amber-50:oklch(98.7% .022 95.277);--color-amber-100:oklch(96.2% .059 95.617);--color-amber-400:oklch(82.8% .189 84.429);--color-amber-700:oklch(55.5% .163 48.998);--color-amber-800:oklch(47.3% .137 46.201);--color-yellow-50:oklch(98.7% .026 102.212);--color-yellow-100:oklch(97.3% .071 103.193);--color-yellow-200:oklch(94.5% .129 101.54);--color-yellow-500:oklch(79.5% .184 86.047);--color-yellow-600:oklch(68.1% .162 75.834);--color-yellow-700:oklch(55.4% .135 66.442);--color-yellow-800:oklch(47.6% .114 61.907);--color-yellow-900:oklch(42.1% .095 57.708);--color-green-50:oklch(98.2% .018 155.826);--color-green-100:oklch(96.2% .044 156.743);--color-green-200:oklch(92.5% .084 155.995);--color-green-500:oklch(72.3% .219 149.579);--color-green-600:oklch(62.7% .194 149.214);--color-green-700:oklch(52.7% .154 150.069);--color-green-800:oklch(44.8% .119 151.328);--color-green-900:oklch(39.3% .095 152.535);--color-blue-50:oklch(97% .014 254.604);--color-blue-100:oklch(93.2% .032 255.585);--color-blue-200:oklch(88.2% .059 254.128);--color-blue-300:oklch(80.9% .105 251.813);--color-blue-500:oklch(62.3% .214 259.815);--color-blue-600:oklch(54.6% .245 262.881);--color-blue-700:oklch(48.8% .243 264.376);--color-blue-800:oklch(42.4% .199 265.638);--color-indigo-50:oklch(96.2% .018 272.314);--color-indigo-100:oklch(93% .034 272.788);--color-indigo-200:oklch(87% .065 274.039);--color-indigo-300:oklch(78.5% .115 274.713);--color-indigo-500:oklch(58.5% .233 277.117);--color-indigo-600:oklch(51.1% .262 276.966);--color-purple-50:oklch(97.7% .014 308.299);--color-purple-600:oklch(55.8% .288 302.321);--color-gray-50:oklch(98.5% .002 247.839);--color-gray-100:oklch(96.7% .003 264.542);--color-gray-200:oklch(92.8% .006 264.531);--color-gray-300:oklch(87.2% .01 258.338);--color-gray-400:oklch(70.7% .022 261.325);--color-gray-500:oklch(55.1% .027 264.364);--color-gray-600:oklch(44.6% .03 256.802);--color-gray-700:oklch(37.3% .034 259.733);--color-gray-800:oklch(27.8% .033 256.848);--color-gray-900:oklch(21% .034 264.665);--color-black:#000;--color-white:#fff;--spacing:.25rem;--container-xs:20rem;--container-sm:24rem;--container-md:28rem;--container-2xl:42rem;--container-4xl:56rem;--container-6xl:72rem;--text-xs:.75rem;--text-xs--line-height:calc(1/.75);--text-sm:.875rem;--text-sm--line-height:calc(1.25/.875);--text-base:1rem;--text-base--line-height:calc(1.5/1);--text-lg:1.125rem;--text-lg--line-height:calc(1.75/1.125);--text-xl:1.25rem;--text-xl--line-height:calc(1.75/1.25);--text-2xl:1.5rem;--text-2xl--line-height:calc(2/1.5);--text-3xl:1.875rem;--text-3xl--line-height:calc(2.25/1.875);--text-4xl:2.25rem;--text-4xl--line-height:calc(2.5/2.25);--text-5xl:3rem;--text-5xl--line-height:1;--font-weight-light:300;--font-weight-normal:400;--font-weight-medium:500;--font-weight-semibold:600;--font-weight-bold:700;--font-weight-extrabold:800;--tracking-tighter:-.05em;--tracking-tight:-.025em;--tracking-wide:.025em;--tracking-wider:.05em;--tracking-widest:.1em;--leading-tight:1.25;--radius-md:.375rem;--radius-lg:.5rem;--radius-xl:.75rem;--radius-2xl:1rem;--drop-shadow-md:0 3px 3px #0000001f;--ease-in:cubic-bezier(.4,0,1,1);--ease-out:cubic-bezier(0,0,.2,1);--ease-in-out:cubic-bezier(.4,0,.2,1);--animate-spin:spin 1s linear infinite;--blur-sm:8px;--default-transition-duration:.15s;--default-transition-timing-function:cubic-bezier(.4,0,.2,1);--default-font-family:var(--font-sans);--default-mono-font-family:var(--font-mono);--color-ink-black-400:#134471;--color-ink-black-500:#061523;--color-graphite-50:#ebebeb;--color-graphite-100:#d6d6d6;--color-graphite-200:#adadad;--color-graphite-300:#858585;--color-graphite-400:#5c5c5c;--color-graphite-500:#333;--color-graphite-600:#292929;--color-graphite-800:#141414;--color-graphite-900:#0a0a0a;--color-brilliant-azure-50:#e9f3fb;--color-brilliant-azure-100:#d4e6f7;--color-brilliant-azure-200:#a9ceef;--color-brilliant-azure-500:#2c86d8;--color-brilliant-azure-600:#216cb0;--color-brilliant-azure-700:#195285;--color-brilliant-azure-800:#103556;--color-brilliant-azure-900:#081a2b;--color-white-600:#c6c6c6}}@layer base{*,:after,:before,::backdrop{box-sizing:border-box;border:0 solid;margin:0;padding:0}::file-selector-button{box-sizing:border-box;border:0 solid;margin:0;padding:0}html,:host{-webkit-text-size-adjust:100%;tab-size:4;line-height:1.5;font-family:var(--default-font-family,ui-sans-serif,system-ui,sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\");font-feature-settings:var(--default-font-feature-settings,normal);font-variation-settings:var(--default-font-variation-settings,normal);-webkit-tap-highlight-color:transparent}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;-webkit-text-decoration:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:var(--default-mono-font-family,ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace);font-feature-settings:var(--default-mono-font-feature-settings,normal);font-variation-settings:var(--default-mono-font-variation-settings,normal);font-size:1em}small{font-size:80%}sub,sup{vertical-align:baseline;font-size:75%;line-height:0;position:relative}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}:-moz-focusring{outline:auto}progress{vertical-align:baseline}summary{display:list-item}ol,ul,menu{list-style:none}img,svg,video,canvas,audio,iframe,embed,object{vertical-align:middle;display:block}img,video{max-width:100%;height:auto}button,input,select,optgroup,textarea{font:inherit;font-feature-settings:inherit;font-variation-settings:inherit;letter-spacing:inherit;color:inherit;opacity:1;background-color:#0000;border-radius:0}::file-selector-button{font:inherit;font-feature-settings:inherit;font-variation-settings:inherit;letter-spacing:inherit;color:inherit;opacity:1;background-color:#0000;border-radius:0}:where(select:is([multiple],[size])) optgroup{font-weight:bolder}:where(select:is([multiple],[size])) optgroup option{padding-inline-start:20px}::file-selector-button{margin-inline-end:4px}::placeholder{opacity:1}@supports (not ((-webkit-appearance:-apple-pay-button))) or (contain-intrinsic-size:1px){::placeholder{color:currentColor}@supports (color:color-mix(in lab, red, red)){::placeholder{color:color-mix(in oklab,currentcolor 50%,transparent)}}}textarea{resize:vertical}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-date-and-time-value{min-height:1lh;text-align:inherit}::-webkit-datetime-edit{display:inline-flex}::-webkit-datetime-edit-fields-wrapper{padding:0}::-webkit-datetime-edit{padding-block:0}::-webkit-datetime-edit-year-field{padding-block:0}::-webkit-datetime-edit-month-field{padding-block:0}::-webkit-datetime-edit-day-field{padding-block:0}::-webkit-datetime-edit-hour-field{padding-block:0}::-webkit-datetime-edit-minute-field{padding-block:0}::-webkit-datetime-edit-second-field{padding-block:0}::-webkit-datetime-edit-millisecond-field{padding-block:0}::-webkit-datetime-edit-meridiem-field{padding-block:0}::-webkit-calendar-picker-indicator{line-height:1}:-moz-ui-invalid{box-shadow:none}button,input:where([type=button],[type=reset],[type=submit]){appearance:button}::file-selector-button{appearance:button}::-webkit-inner-spin-button{height:auto}::-webkit-outer-spin-button{height:auto}[hidden]:where(:not([hidden=until-found])){display:none!important}html{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-family:Roboto,sans-serif,Arial}h1,h2,h3,h4,h5,h6{font-family:system-ui,-apple-system,BlinkMacSystemFont,Segoe UI}}@layer components;@layer utilities{.pointer-events-none{pointer-events:none}.visible{visibility:visible}.absolute{position:absolute}.fixed{position:fixed}.relative{position:relative}.static{position:static}.sticky{position:sticky}.inset-0{inset:calc(var(--spacing)*0)}.inset-y-0{inset-block:calc(var(--spacing)*0)}.top-0{top:calc(var(--spacing)*0)}.top-2{top:calc(var(--spacing)*2)}.top-3{top:calc(var(--spacing)*3)}.right-0{right:calc(var(--spacing)*0)}.right-2{right:calc(var(--spacing)*2)}.bottom-2{bottom:calc(var(--spacing)*2)}.bottom-full{bottom:100%}.left-0{left:calc(var(--spacing)*0)}.left-2{left:calc(var(--spacing)*2)}.left-3{left:calc(var(--spacing)*3)}.z-10{z-index:10}.z-20{z-index:20}.z-40{z-index:40}.z-50{z-index:50}.order-1{order:1}.order-2{order:2}.order-3{order:3}.order-4{order:4}.container{width:100%}@media (width>=40rem){.container{max-width:40rem}}@media (width>=48rem){.container{max-width:48rem}}@media (width>=64rem){.container{max-width:64rem}}@media (width>=80rem){.container{max-width:80rem}}@media (width>=96rem){.container{max-width:96rem}}.m-0{margin:calc(var(--spacing)*0)}.mx-1{margin-inline:calc(var(--spacing)*1)}.mx-4{margin-inline:calc(var(--spacing)*4)}.mx-auto{margin-inline:auto}.my-4{margin-block:calc(var(--spacing)*4)}.mt-0\\.5{margin-top:calc(var(--spacing)*.5)}.mt-1{margin-top:calc(var(--spacing)*1)}.mt-2{margin-top:calc(var(--spacing)*2)}.mt-3{margin-top:calc(var(--spacing)*3)}.mt-4{margin-top:calc(var(--spacing)*4)}.mt-6{margin-top:calc(var(--spacing)*6)}.mt-8{margin-top:calc(var(--spacing)*8)}.mr-2{margin-right:calc(var(--spacing)*2)}.mr-3{margin-right:calc(var(--spacing)*3)}.mr-4{margin-right:calc(var(--spacing)*4)}.mr-5{margin-right:calc(var(--spacing)*5)}.nav-item{color:var(--color-graphite-500);border-left:4px solid #0000;border-radius:.375rem;align-items:center;margin-bottom:2px;padding:.375rem .75rem .375rem 3rem;line-height:1.25;transition:all .15s ease-in-out;display:flex;text-decoration:none!important}.nav-item:hover{color:var(--color-brilliant-azure-700);background-color:var(--color-white-600)}.nav-item.active{color:var(--color-brilliant-azure-500)!important;background-color:var(--color-brilliant-azure-50)!important;border-left-color:var(--color-brilliant-azure-500)!important}.nav-item.level-0{padding-left:.75rem;font-family:system-ui,-apple-system,sans-serif;font-size:.9rem;font-weight:700}.nav-item.level-1{font-family:Roboto,sans-serif;font-size:.87rem;font-weight:400}.-mb-px{margin-bottom:-1px}.mb-1{margin-bottom:calc(var(--spacing)*1)}.mb-2{margin-bottom:calc(var(--spacing)*2)}.mb-3{margin-bottom:calc(var(--spacing)*3)}.mb-4{margin-bottom:calc(var(--spacing)*4)}.mb-6{margin-bottom:calc(var(--spacing)*6)}.mb-8{margin-bottom:calc(var(--spacing)*8)}.mb-\\[20px\\]{margin-bottom:20px}.ml-1{margin-left:calc(var(--spacing)*1)}.ml-1\\.5{margin-left:calc(var(--spacing)*1.5)}.ml-2{margin-left:calc(var(--spacing)*2)}.ml-3{margin-left:calc(var(--spacing)*3)}.ml-4{margin-left:calc(var(--spacing)*4)}.ml-auto{margin-left:auto}.block{display:block}.contents{display:contents}.flex{display:flex}.grid{display:grid}.hidden{display:none}.inline{display:inline}.inline-block{display:inline-block}.inline-flex{display:inline-flex}.table{display:table}.h-1\\.5{height:calc(var(--spacing)*1.5)}.h-2{height:calc(var(--spacing)*2)}.h-3{height:calc(var(--spacing)*3)}.h-4{height:calc(var(--spacing)*4)}.h-5{height:calc(var(--spacing)*5)}.h-6{height:calc(var(--spacing)*6)}.h-7{height:calc(var(--spacing)*7)}.h-8{height:calc(var(--spacing)*8)}.h-10{height:calc(var(--spacing)*10)}.h-12{height:calc(var(--spacing)*12)}.h-14{height:calc(var(--spacing)*14)}.h-16{height:calc(var(--spacing)*16)}.h-20{height:calc(var(--spacing)*20)}.h-\\[220px\\]{height:220px}.h-auto{height:auto}.h-full{height:100%}.max-h-48{max-height:calc(var(--spacing)*48)}.max-h-full{max-height:100%}.min-h-0{min-height:calc(var(--spacing)*0)}.min-h-\\[2\\.5rem\\]{min-height:2.5rem}.min-h-\\[300px\\]{min-height:300px}.min-h-\\[400px\\]{min-height:400px}.min-h-screen{min-height:100vh}.w-1\\.5{width:calc(var(--spacing)*1.5)}.w-1\\/3{width:33.3333%}.w-3{width:calc(var(--spacing)*3)}.w-4{width:calc(var(--spacing)*4)}.w-5{width:calc(var(--spacing)*5)}.w-6{width:calc(var(--spacing)*6)}.w-7{width:calc(var(--spacing)*7)}.w-8{width:calc(var(--spacing)*8)}.w-10{width:calc(var(--spacing)*10)}.w-12{width:calc(var(--spacing)*12)}.w-14{width:calc(var(--spacing)*14)}.w-16{width:calc(var(--spacing)*16)}.w-20{width:calc(var(--spacing)*20)}.w-24{width:calc(var(--spacing)*24)}.w-28{width:calc(var(--spacing)*28)}.w-32{width:calc(var(--spacing)*32)}.w-64{width:calc(var(--spacing)*64)}.w-\\[200px\\]{width:200px}.w-\\[220px\\]{width:220px}.w-auto{width:auto}.w-full{width:100%}.w-px{width:1px}.max-w-2xl{max-width:var(--container-2xl)}.max-w-4xl{max-width:var(--container-4xl)}.max-w-6xl{max-width:var(--container-6xl)}.max-w-full{max-width:100%}.max-w-md{max-width:var(--container-md)}.max-w-sm{max-width:var(--container-sm)}.max-w-xs{max-width:var(--container-xs)}.min-w-0{min-width:calc(var(--spacing)*0)}.min-w-\\[200px\\]{min-width:200px}.min-w-\\[300px\\]{min-width:300px}.min-w-full{min-width:100%}.flex-1{flex:1}.flex-shrink{flex-shrink:1}.flex-shrink-0{flex-shrink:0}.flex-grow{flex-grow:1}.-translate-x-full{--tw-translate-x:-100%;translate:var(--tw-translate-x)var(--tw-translate-y)}.transform{transform:var(--tw-rotate-x, )var(--tw-rotate-y, )var(--tw-rotate-z, )var(--tw-skew-x, )var(--tw-skew-y, )}.animate-spin{animation:var(--animate-spin)}.cursor-not-allowed{cursor:not-allowed}.cursor-pointer{cursor:pointer}.resize{resize:both}.resize-none{resize:none}.list-none{list-style-type:none}.appearance-none{appearance:none}.grid-cols-1{grid-template-columns:repeat(1,minmax(0,1fr))}.grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.grid-cols-6{grid-template-columns:repeat(6,minmax(0,1fr))}.grid-cols-\\[1fr_1fr_6rem\\]{grid-template-columns:1fr 1fr 6rem}.flex-col{flex-direction:column}.flex-row{flex-direction:row}.flex-row-reverse{flex-direction:row-reverse}.flex-wrap{flex-wrap:wrap}.items-center{align-items:center}.items-end{align-items:flex-end}.items-start{align-items:flex-start}.justify-between{justify-content:space-between}.justify-center{justify-content:center}.justify-end{justify-content:flex-end}.gap-1{gap:calc(var(--spacing)*1)}.gap-1\\.5{gap:calc(var(--spacing)*1.5)}.gap-2{gap:calc(var(--spacing)*2)}.gap-3{gap:calc(var(--spacing)*3)}.gap-4{gap:calc(var(--spacing)*4)}.gap-5{gap:calc(var(--spacing)*5)}.gap-6{gap:calc(var(--spacing)*6)}:where(.space-y-0>:not(:last-child)){--tw-space-y-reverse:0;margin-block-start:calc(calc(var(--spacing)*0)*var(--tw-space-y-reverse));margin-block-end:calc(calc(var(--spacing)*0)*calc(1 - var(--tw-space-y-reverse)))}:where(.space-y-1>:not(:last-child)){--tw-space-y-reverse:0;margin-block-start:calc(calc(var(--spacing)*1)*var(--tw-space-y-reverse));margin-block-end:calc(calc(var(--spacing)*1)*calc(1 - var(--tw-space-y-reverse)))}:where(.space-y-2>:not(:last-child)){--tw-space-y-reverse:0;margin-block-start:calc(calc(var(--spacing)*2)*var(--tw-space-y-reverse));margin-block-end:calc(calc(var(--spacing)*2)*calc(1 - var(--tw-space-y-reverse)))}:where(.space-y-3>:not(:last-child)){--tw-space-y-reverse:0;margin-block-start:calc(calc(var(--spacing)*3)*var(--tw-space-y-reverse));margin-block-end:calc(calc(var(--spacing)*3)*calc(1 - var(--tw-space-y-reverse)))}:where(.space-y-4>:not(:last-child)){--tw-space-y-reverse:0;margin-block-start:calc(calc(var(--spacing)*4)*var(--tw-space-y-reverse));margin-block-end:calc(calc(var(--spacing)*4)*calc(1 - var(--tw-space-y-reverse)))}:where(.space-y-6>:not(:last-child)){--tw-space-y-reverse:0;margin-block-start:calc(calc(var(--spacing)*6)*var(--tw-space-y-reverse));margin-block-end:calc(calc(var(--spacing)*6)*calc(1 - var(--tw-space-y-reverse)))}:where(.space-y-8>:not(:last-child)){--tw-space-y-reverse:0;margin-block-start:calc(calc(var(--spacing)*8)*var(--tw-space-y-reverse));margin-block-end:calc(calc(var(--spacing)*8)*calc(1 - var(--tw-space-y-reverse)))}:where(.divide-x-0>:not(:last-child)){--tw-divide-x-reverse:0;border-inline-style:var(--tw-border-style);border-inline-start-width:calc(0px*var(--tw-divide-x-reverse));border-inline-end-width:calc(0px*calc(1 - var(--tw-divide-x-reverse)))}:where(.divide-y>:not(:last-child)){--tw-divide-y-reverse:0;border-bottom-style:var(--tw-border-style);border-top-style:var(--tw-border-style);border-top-width:calc(1px*var(--tw-divide-y-reverse));border-bottom-width:calc(1px*calc(1 - var(--tw-divide-y-reverse)))}:where(.divide-gray-100>:not(:last-child)){border-color:var(--color-gray-100)}:where(.divide-gray-200>:not(:last-child)){border-color:var(--color-gray-200)}.truncate{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.overflow-auto{overflow:auto}.overflow-hidden{overflow:hidden}.overflow-x-auto{overflow-x:auto}.overflow-y-auto{overflow-y:auto}.overscroll-contain{overscroll-behavior:contain}.rounded{border-radius:.25rem}.rounded-2xl{border-radius:var(--radius-2xl)}.rounded-full{border-radius:3.40282e38px}.rounded-lg{border-radius:var(--radius-lg)}.rounded-md{border-radius:var(--radius-md)}.rounded-none{border-radius:0}.rounded-xl{border-radius:var(--radius-xl)}.rounded-t{border-top-left-radius:.25rem;border-top-right-radius:.25rem}.rounded-t-lg{border-top-left-radius:var(--radius-lg);border-top-right-radius:var(--radius-lg)}.rounded-t-md{border-top-left-radius:var(--radius-md);border-top-right-radius:var(--radius-md)}.rounded-t-none{border-top-left-radius:0;border-top-right-radius:0}.rounded-tr-xl{border-top-right-radius:var(--radius-xl)}.rounded-bl-lg{border-bottom-left-radius:var(--radius-lg)}.border{border-style:var(--tw-border-style);border-width:1px}.border-2{border-style:var(--tw-border-style);border-width:2px}.border-t{border-top-style:var(--tw-border-style);border-top-width:1px}.border-r{border-right-style:var(--tw-border-style);border-right-width:1px}.border-b{border-bottom-style:var(--tw-border-style);border-bottom-width:1px}.border-b-0{border-bottom-style:var(--tw-border-style);border-bottom-width:0}.border-l{border-left-style:var(--tw-border-style);border-left-width:1px}.border-l-4{border-left-style:var(--tw-border-style);border-left-width:4px}.border-dashed{--tw-border-style:dashed;border-style:dashed}.border-amber-400{border-color:var(--color-amber-400)}.border-blue-500{border-color:var(--color-blue-500)}.border-blue-600{border-color:var(--color-blue-600)}.border-brilliant-azure-200{border-color:var(--color-brilliant-azure-200)}.border-brilliant-azure-500{border-color:var(--color-brilliant-azure-500)}.border-graphite-200{border-color:var(--color-graphite-200)}.border-graphite-300{border-color:var(--color-graphite-300)}.border-gray-50{border-color:var(--color-gray-50)}.border-gray-100{border-color:var(--color-gray-100)}.border-gray-200{border-color:var(--color-gray-200)}.border-gray-300{border-color:var(--color-gray-300)}.border-gray-700\\/50{border-color:#36415380}@supports (color:color-mix(in lab, red, red)){.border-gray-700\\/50{border-color:color-mix(in oklab,var(--color-gray-700)50%,transparent)}}.border-indigo-100{border-color:var(--color-indigo-100)}.border-indigo-200{border-color:var(--color-indigo-200)}.border-red-500{border-color:var(--color-red-500)}.border-transparent{border-color:#0000}.bg-amber-50{background-color:var(--color-amber-50)}.bg-amber-100{background-color:var(--color-amber-100)}.bg-black{background-color:var(--color-black)}.bg-black\\/10{background-color:#0000001a}@supports (color:color-mix(in lab, red, red)){.bg-black\\/10{background-color:color-mix(in oklab,var(--color-black)10%,transparent)}}.bg-blue-50{background-color:var(--color-blue-50)}.bg-blue-500{background-color:var(--color-blue-500)}.bg-blue-600{background-color:var(--color-blue-600)}.bg-brilliant-azure-50{background-color:var(--color-brilliant-azure-50)}.bg-brilliant-azure-100{background-color:var(--color-brilliant-azure-100)}.bg-brilliant-azure-500{background-color:var(--color-brilliant-azure-500)}.bg-graphite-100{background-color:var(--color-graphite-100)}.bg-graphite-500{background-color:var(--color-graphite-500)}.bg-graphite-800{background-color:var(--color-graphite-800)}.bg-gray-50{background-color:var(--color-gray-50)}.bg-gray-50\\/30{background-color:#f9fafb4d}@supports (color:color-mix(in lab, red, red)){.bg-gray-50\\/30{background-color:color-mix(in oklab,var(--color-gray-50)30%,transparent)}}.bg-gray-50\\/50{background-color:#f9fafb80}@supports (color:color-mix(in lab, red, red)){.bg-gray-50\\/50{background-color:color-mix(in oklab,var(--color-gray-50)50%,transparent)}}.bg-gray-100{background-color:var(--color-gray-100)}.bg-gray-200{background-color:var(--color-gray-200)}.bg-gray-300{background-color:var(--color-gray-300)}.bg-gray-800{background-color:var(--color-gray-800)}.bg-green-50{background-color:var(--color-green-50)}.bg-green-100{background-color:var(--color-green-100)}.bg-green-600{background-color:var(--color-green-600)}.bg-green-800{background-color:var(--color-green-800)}.bg-indigo-50\\/20{background-color:#eef2ff33}@supports (color:color-mix(in lab, red, red)){.bg-indigo-50\\/20{background-color:color-mix(in oklab,var(--color-indigo-50)20%,transparent)}}.bg-ink-black-400{background-color:var(--color-ink-black-400)}.bg-ink-black-500\\/20{background-color:#06152333}@supports (color:color-mix(in lab, red, red)){.bg-ink-black-500\\/20{background-color:color-mix(in oklab,var(--color-ink-black-500)20%,transparent)}}.bg-ink-black-500\\/95{background-color:#061523f2}@supports (color:color-mix(in lab, red, red)){.bg-ink-black-500\\/95{background-color:color-mix(in oklab,var(--color-ink-black-500)95%,transparent)}}.bg-purple-50{background-color:var(--color-purple-50)}.bg-red-50{background-color:var(--color-red-50)}.bg-red-100{background-color:var(--color-red-100)}.bg-red-200{background-color:var(--color-red-200)}.bg-red-600{background-color:var(--color-red-600)}.bg-red-800{background-color:var(--color-red-800)}.bg-white{background-color:var(--color-white)}.bg-white\\/50{background-color:#ffffff80}@supports (color:color-mix(in lab, red, red)){.bg-white\\/50{background-color:color-mix(in oklab,var(--color-white)50%,transparent)}}.bg-white\\/70{background-color:#ffffffb3}@supports (color:color-mix(in lab, red, red)){.bg-white\\/70{background-color:color-mix(in oklab,var(--color-white)70%,transparent)}}.bg-white\\/80{background-color:#fffc}@supports (color:color-mix(in lab, red, red)){.bg-white\\/80{background-color:color-mix(in oklab,var(--color-white)80%,transparent)}}.bg-white\\/90{background-color:#ffffffe6}@supports (color:color-mix(in lab, red, red)){.bg-white\\/90{background-color:color-mix(in oklab,var(--color-white)90%,transparent)}}.bg-yellow-50{background-color:var(--color-yellow-50)}.bg-yellow-100{background-color:var(--color-yellow-100)}.bg-yellow-600{background-color:var(--color-yellow-600)}.bg-yellow-800{background-color:var(--color-yellow-800)}.bg-gradient-to-b{--tw-gradient-position:to bottom in oklab;background-image:linear-gradient(var(--tw-gradient-stops))}.bg-gradient-to-r{--tw-gradient-position:to right in oklab;background-image:linear-gradient(var(--tw-gradient-stops))}.from-brilliant-azure-50{--tw-gradient-from:var(--color-brilliant-azure-50);--tw-gradient-stops:var(--tw-gradient-via-stops,var(--tw-gradient-position),var(--tw-gradient-from)var(--tw-gradient-from-position),var(--tw-gradient-to)var(--tw-gradient-to-position))}.from-brilliant-azure-500{--tw-gradient-from:var(--color-brilliant-azure-500);--tw-gradient-stops:var(--tw-gradient-via-stops,var(--tw-gradient-position),var(--tw-gradient-from)var(--tw-gradient-from-position),var(--tw-gradient-to)var(--tw-gradient-to-position))}.to-blue-50{--tw-gradient-to:var(--color-blue-50);--tw-gradient-stops:var(--tw-gradient-via-stops,var(--tw-gradient-position),var(--tw-gradient-from)var(--tw-gradient-from-position),var(--tw-gradient-to)var(--tw-gradient-to-position))}.to-blue-600{--tw-gradient-to:var(--color-blue-600);--tw-gradient-stops:var(--tw-gradient-via-stops,var(--tw-gradient-position),var(--tw-gradient-from)var(--tw-gradient-from-position),var(--tw-gradient-to)var(--tw-gradient-to-position))}.to-white{--tw-gradient-to:var(--color-white);--tw-gradient-stops:var(--tw-gradient-via-stops,var(--tw-gradient-position),var(--tw-gradient-from)var(--tw-gradient-from-position),var(--tw-gradient-to)var(--tw-gradient-to-position))}.bg-\\[length\\:70\\%_70\\%\\]{background-size:70% 70%}.bg-center{background-position:50%}.bg-no-repeat{background-repeat:no-repeat}.object-contain{object-fit:contain}.object-cover{object-fit:cover}.p-0{padding:calc(var(--spacing)*0)}.p-1{padding:calc(var(--spacing)*1)}.p-1\\.5{padding:calc(var(--spacing)*1.5)}.p-2{padding:calc(var(--spacing)*2)}.p-3{padding:calc(var(--spacing)*3)}.p-4{padding:calc(var(--spacing)*4)}.p-6{padding:calc(var(--spacing)*6)}.p-8{padding:calc(var(--spacing)*8)}.p-10{padding:calc(var(--spacing)*10)}.px-1{padding-inline:calc(var(--spacing)*1)}.px-2{padding-inline:calc(var(--spacing)*2)}.px-3{padding-inline:calc(var(--spacing)*3)}.px-4{padding-inline:calc(var(--spacing)*4)}.px-5{padding-inline:calc(var(--spacing)*5)}.px-6{padding-inline:calc(var(--spacing)*6)}.py-0\\.5{padding-block:calc(var(--spacing)*.5)}.py-1{padding-block:calc(var(--spacing)*1)}.py-1\\.5{padding-block:calc(var(--spacing)*1.5)}.py-2{padding-block:calc(var(--spacing)*2)}.py-2\\.5{padding-block:calc(var(--spacing)*2.5)}.py-3{padding-block:calc(var(--spacing)*3)}.py-4{padding-block:calc(var(--spacing)*4)}.py-6{padding-block:calc(var(--spacing)*6)}.py-10{padding-block:calc(var(--spacing)*10)}.py-12{padding-block:calc(var(--spacing)*12)}.py-16{padding-block:calc(var(--spacing)*16)}.py-20{padding-block:calc(var(--spacing)*20)}.pt-2{padding-top:calc(var(--spacing)*2)}.pt-3{padding-top:calc(var(--spacing)*3)}.pt-4{padding-top:calc(var(--spacing)*4)}.pt-5{padding-top:calc(var(--spacing)*5)}.pt-6{padding-top:calc(var(--spacing)*6)}.pr-2{padding-right:calc(var(--spacing)*2)}.pr-3{padding-right:calc(var(--spacing)*3)}.pr-4{padding-right:calc(var(--spacing)*4)}.pb-2{padding-bottom:calc(var(--spacing)*2)}.pb-3{padding-bottom:calc(var(--spacing)*3)}.pb-4{padding-bottom:calc(var(--spacing)*4)}.pb-6{padding-bottom:calc(var(--spacing)*6)}.pl-1{padding-left:calc(var(--spacing)*1)}.pl-3{padding-left:calc(var(--spacing)*3)}.pl-4{padding-left:calc(var(--spacing)*4)}.pl-6{padding-left:calc(var(--spacing)*6)}.pl-7{padding-left:calc(var(--spacing)*7)}.text-center{text-align:center}.text-left{text-align:left}.text-right{text-align:right}.font-mono{font-family:var(--font-mono)}.text-2xl{font-size:var(--text-2xl);line-height:var(--tw-leading,var(--text-2xl--line-height))}.text-3xl{font-size:var(--text-3xl);line-height:var(--tw-leading,var(--text-3xl--line-height))}.text-4xl{font-size:var(--text-4xl);line-height:var(--tw-leading,var(--text-4xl--line-height))}.text-5xl{font-size:var(--text-5xl);line-height:var(--tw-leading,var(--text-5xl--line-height))}.text-base{font-size:var(--text-base);line-height:var(--tw-leading,var(--text-base--line-height))}.text-lg{font-size:var(--text-lg);line-height:var(--tw-leading,var(--text-lg--line-height))}.text-sm{font-size:var(--text-sm);line-height:var(--tw-leading,var(--text-sm--line-height))}.text-xl{font-size:var(--text-xl);line-height:var(--tw-leading,var(--text-xl--line-height))}.text-xs{font-size:var(--text-xs);line-height:var(--tw-leading,var(--text-xs--line-height))}.text-\\[10px\\]{font-size:10px}.text-\\[11px\\]{font-size:11px}.leading-5{--tw-leading:calc(var(--spacing)*5);line-height:calc(var(--spacing)*5)}.leading-none{--tw-leading:1;line-height:1}.leading-tight{--tw-leading:var(--leading-tight);line-height:var(--leading-tight)}.font-bold{--tw-font-weight:var(--font-weight-bold);font-weight:var(--font-weight-bold)}.font-extrabold{--tw-font-weight:var(--font-weight-extrabold);font-weight:var(--font-weight-extrabold)}.font-light{--tw-font-weight:var(--font-weight-light);font-weight:var(--font-weight-light)}.font-medium{--tw-font-weight:var(--font-weight-medium);font-weight:var(--font-weight-medium)}.font-normal{--tw-font-weight:var(--font-weight-normal);font-weight:var(--font-weight-normal)}.font-semibold{--tw-font-weight:var(--font-weight-semibold);font-weight:var(--font-weight-semibold)}.tracking-tight{--tw-tracking:var(--tracking-tight);letter-spacing:var(--tracking-tight)}.tracking-tighter{--tw-tracking:var(--tracking-tighter);letter-spacing:var(--tracking-tighter)}.tracking-wide{--tw-tracking:var(--tracking-wide);letter-spacing:var(--tracking-wide)}.tracking-wider{--tw-tracking:var(--tracking-wider);letter-spacing:var(--tracking-wider)}.tracking-widest{--tw-tracking:var(--tracking-widest);letter-spacing:var(--tracking-widest)}.break-all{word-break:break-all}.whitespace-nowrap{white-space:nowrap}.text-amber-400{color:var(--color-amber-400)}.text-amber-700{color:var(--color-amber-700)}.text-amber-800{color:var(--color-amber-800)}.text-blue-500{color:var(--color-blue-500)}.text-blue-600{color:var(--color-blue-600)}.text-blue-800{color:var(--color-blue-800)}.text-brilliant-azure-500{color:var(--color-brilliant-azure-500)}.text-brilliant-azure-600{color:var(--color-brilliant-azure-600)}.text-brilliant-azure-800{color:var(--color-brilliant-azure-800)}.text-graphite-200{color:var(--color-graphite-200)}.text-graphite-400{color:var(--color-graphite-400)}.text-graphite-500{color:var(--color-graphite-500)}.text-graphite-600{color:var(--color-graphite-600)}.text-graphite-800{color:var(--color-graphite-800)}.text-gray-100{color:var(--color-gray-100)}.text-gray-300{color:var(--color-gray-300)}.text-gray-400{color:var(--color-gray-400)}.text-gray-500{color:var(--color-gray-500)}.text-gray-600{color:var(--color-gray-600)}.text-gray-700{color:var(--color-gray-700)}.text-gray-800{color:var(--color-gray-800)}.text-gray-900{color:var(--color-gray-900)}.text-green-500{color:var(--color-green-500)}.text-green-600{color:var(--color-green-600)}.text-green-700{color:var(--color-green-700)}.text-green-800{color:var(--color-green-800)}.text-indigo-500{color:var(--color-indigo-500)}.text-indigo-600{color:var(--color-indigo-600)}.text-ink-black-500{color:var(--color-ink-black-500)}.text-purple-600{color:var(--color-purple-600)}.text-red-500{color:var(--color-red-500)}.text-red-600{color:var(--color-red-600)}.text-red-700{color:var(--color-red-700)}.text-red-800{color:var(--color-red-800)}.text-white{color:var(--color-white)}.text-yellow-600{color:var(--color-yellow-600)}.text-yellow-800{color:var(--color-yellow-800)}.capitalize{text-transform:capitalize}.uppercase{text-transform:uppercase}.italic{font-style:italic}.no-underline{text-decoration-line:none}.placeholder-graphite-400::placeholder{color:var(--color-graphite-400)}.placeholder-gray-500::placeholder{color:var(--color-gray-500)}.opacity-0{opacity:0}.opacity-25{opacity:.25}.opacity-60{opacity:.6}.opacity-75{opacity:.75}.opacity-80{opacity:.8}.opacity-90{opacity:.9}.opacity-100{opacity:1}.shadow{--tw-shadow:0 1px 3px 0 var(--tw-shadow-color,#0000001a),0 1px 2px -1px var(--tw-shadow-color,#0000001a);box-shadow:var(--tw-inset-shadow),var(--tw-inset-ring-shadow),var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow)}.shadow-2xl{--tw-shadow:0 25px 50px -12px var(--tw-shadow-color,#00000040);box-shadow:var(--tw-inset-shadow),var(--tw-inset-ring-shadow),var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow)}.shadow-lg{--tw-shadow:0 10px 15px -3px var(--tw-shadow-color,#0000001a),0 4px 6px -4px var(--tw-shadow-color,#0000001a);box-shadow:var(--tw-inset-shadow),var(--tw-inset-ring-shadow),var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow)}.shadow-sm{--tw-shadow:0 1px 3px 0 var(--tw-shadow-color,#0000001a),0 1px 2px -1px var(--tw-shadow-color,#0000001a);box-shadow:var(--tw-inset-shadow),var(--tw-inset-ring-shadow),var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow)}.shadow-xl{--tw-shadow:0 20px 25px -5px var(--tw-shadow-color,#0000001a),0 8px 10px -6px var(--tw-shadow-color,#0000001a);box-shadow:var(--tw-inset-shadow),var(--tw-inset-ring-shadow),var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow)}.ring-2{--tw-ring-shadow:var(--tw-ring-inset, )0 0 0 calc(2px + var(--tw-ring-offset-width))var(--tw-ring-color,currentcolor);box-shadow:var(--tw-inset-shadow),var(--tw-inset-ring-shadow),var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow)}.ring-white{--tw-ring-color:var(--color-white)}.outline{outline-style:var(--tw-outline-style);outline-width:1px}.blur{--tw-blur:blur(8px);filter:var(--tw-blur, )var(--tw-brightness, )var(--tw-contrast, )var(--tw-grayscale, )var(--tw-hue-rotate, )var(--tw-invert, )var(--tw-saturate, )var(--tw-sepia, )var(--tw-drop-shadow, )}.drop-shadow-md{--tw-drop-shadow-size:drop-shadow(0 3px 3px var(--tw-drop-shadow-color,#0000001f));--tw-drop-shadow:drop-shadow(var(--drop-shadow-md));filter:var(--tw-blur, )var(--tw-brightness, )var(--tw-contrast, )var(--tw-grayscale, )var(--tw-hue-rotate, )var(--tw-invert, )var(--tw-saturate, )var(--tw-sepia, )var(--tw-drop-shadow, )}.filter{filter:var(--tw-blur, )var(--tw-brightness, )var(--tw-contrast, )var(--tw-grayscale, )var(--tw-hue-rotate, )var(--tw-invert, )var(--tw-saturate, )var(--tw-sepia, )var(--tw-drop-shadow, )}.backdrop-blur-\\[1px\\]{--tw-backdrop-blur:blur(1px);backdrop-filter:var(--tw-backdrop-blur, )var(--tw-backdrop-brightness, )var(--tw-backdrop-contrast, )var(--tw-backdrop-grayscale, )var(--tw-backdrop-hue-rotate, )var(--tw-backdrop-invert, )var(--tw-backdrop-opacity, )var(--tw-backdrop-saturate, )var(--tw-backdrop-sepia, )}.backdrop-blur-sm{--tw-backdrop-blur:blur(var(--blur-sm));backdrop-filter:var(--tw-backdrop-blur, )var(--tw-backdrop-brightness, )var(--tw-backdrop-contrast, )var(--tw-backdrop-grayscale, )var(--tw-backdrop-hue-rotate, )var(--tw-backdrop-invert, )var(--tw-backdrop-opacity, )var(--tw-backdrop-saturate, )var(--tw-backdrop-sepia, )}.backdrop-filter{backdrop-filter:var(--tw-backdrop-blur, )var(--tw-backdrop-brightness, )var(--tw-backdrop-contrast, )var(--tw-backdrop-grayscale, )var(--tw-backdrop-hue-rotate, )var(--tw-backdrop-invert, )var(--tw-backdrop-opacity, )var(--tw-backdrop-saturate, )var(--tw-backdrop-sepia, )}.transition{transition-property:color,background-color,border-color,outline-color,text-decoration-color,fill,stroke,--tw-gradient-from,--tw-gradient-via,--tw-gradient-to,opacity,box-shadow,transform,translate,scale,rotate,filter,backdrop-filter,display,content-visibility,overlay,pointer-events;transition-timing-function:var(--tw-ease,var(--default-transition-timing-function));transition-duration:var(--tw-duration,var(--default-transition-duration))}.transition-all{transition-property:all;transition-timing-function:var(--tw-ease,var(--default-transition-timing-function));transition-duration:var(--tw-duration,var(--default-transition-duration))}.transition-colors{transition-property:color,background-color,border-color,outline-color,text-decoration-color,fill,stroke,--tw-gradient-from,--tw-gradient-via,--tw-gradient-to;transition-timing-function:var(--tw-ease,var(--default-transition-timing-function));transition-duration:var(--tw-duration,var(--default-transition-duration))}.transition-opacity{transition-property:opacity;transition-timing-function:var(--tw-ease,var(--default-transition-timing-function));transition-duration:var(--tw-duration,var(--default-transition-duration))}.transition-transform{transition-property:transform,translate,scale,rotate;transition-timing-function:var(--tw-ease,var(--default-transition-timing-function));transition-duration:var(--tw-duration,var(--default-transition-duration))}.duration-150{--tw-duration:.15s;transition-duration:.15s}.duration-200{--tw-duration:.2s;transition-duration:.2s}.duration-300{--tw-duration:.3s;transition-duration:.3s}.ease-in{--tw-ease:var(--ease-in);transition-timing-function:var(--ease-in)}.ease-in-out{--tw-ease:var(--ease-in-out);transition-timing-function:var(--ease-in-out)}.ease-out{--tw-ease:var(--ease-out);transition-timing-function:var(--ease-out)}.outline-none{--tw-outline-style:none;outline-style:none}.select-none{user-select:none}@media (hover:hover){.group-hover\\:opacity-100:is(:where(.group):hover *){opacity:1}.group-hover\\/tooltip\\:block:is(:where(.group\\/tooltip):hover *){display:block}}.peer-checked\\:text-orange-500:is(:where(.peer):checked~*){color:var(--color-orange-500)}.peer-invalid\\:block:is(:where(.peer):invalid~*){display:block}.last\\:border-0:last-child{border-style:var(--tw-border-style);border-width:0}.invalid\\:border-red-500:invalid{border-color:var(--color-red-500)}.invalid\\:text-red-900:invalid{color:var(--color-red-900)}@media (hover:hover){.hover\\:scale-105:hover{--tw-scale-x:105%;--tw-scale-y:105%;--tw-scale-z:105%;scale:var(--tw-scale-x)var(--tw-scale-y)}.hover\\:border-blue-300:hover{border-color:var(--color-blue-300)}.hover\\:border-gray-300:hover{border-color:var(--color-gray-300)}.hover\\:border-gray-400:hover{border-color:var(--color-gray-400)}.hover\\:border-indigo-300:hover{border-color:var(--color-indigo-300)}.hover\\:bg-blue-50:hover{background-color:var(--color-blue-50)}.hover\\:bg-blue-100:hover{background-color:var(--color-blue-100)}.hover\\:bg-blue-700:hover{background-color:var(--color-blue-700)}.hover\\:bg-brilliant-azure-200:hover{background-color:var(--color-brilliant-azure-200)}.hover\\:bg-brilliant-azure-600:hover{background-color:var(--color-brilliant-azure-600)}.hover\\:bg-brilliant-azure-700:hover{background-color:var(--color-brilliant-azure-700)}.hover\\:bg-graphite-200:hover{background-color:var(--color-graphite-200)}.hover\\:bg-graphite-600:hover{background-color:var(--color-graphite-600)}.hover\\:bg-graphite-900:hover{background-color:var(--color-graphite-900)}.hover\\:bg-gray-50:hover{background-color:var(--color-gray-50)}.hover\\:bg-gray-100:hover{background-color:var(--color-gray-100)}.hover\\:bg-green-100:hover{background-color:var(--color-green-100)}.hover\\:bg-green-200:hover{background-color:var(--color-green-200)}.hover\\:bg-green-700:hover{background-color:var(--color-green-700)}.hover\\:bg-green-900:hover{background-color:var(--color-green-900)}.hover\\:bg-indigo-50:hover{background-color:var(--color-indigo-50)}.hover\\:bg-ink-black-500:hover{background-color:var(--color-ink-black-500)}.hover\\:bg-red-50:hover{background-color:var(--color-red-50)}.hover\\:bg-red-100:hover{background-color:var(--color-red-100)}.hover\\:bg-red-200:hover{background-color:var(--color-red-200)}.hover\\:bg-red-700:hover{background-color:var(--color-red-700)}.hover\\:bg-red-900:hover{background-color:var(--color-red-900)}.hover\\:bg-white:hover{background-color:var(--color-white)}.hover\\:bg-white\\/10:hover{background-color:#ffffff1a}@supports (color:color-mix(in lab, red, red)){.hover\\:bg-white\\/10:hover{background-color:color-mix(in oklab,var(--color-white)10%,transparent)}}.hover\\:bg-yellow-200:hover{background-color:var(--color-yellow-200)}.hover\\:bg-yellow-700:hover{background-color:var(--color-yellow-700)}.hover\\:bg-yellow-900:hover{background-color:var(--color-yellow-900)}.hover\\:text-blue-500:hover{color:var(--color-blue-500)}.hover\\:text-blue-600:hover{color:var(--color-blue-600)}.hover\\:text-brilliant-azure-500:hover{color:var(--color-brilliant-azure-500)}.hover\\:text-brilliant-azure-900:hover{color:var(--color-brilliant-azure-900)}.hover\\:text-gray-200:hover{color:var(--color-gray-200)}.hover\\:text-gray-600:hover{color:var(--color-gray-600)}.hover\\:text-gray-700:hover{color:var(--color-gray-700)}.hover\\:text-orange-500:hover{color:var(--color-orange-500)}.hover\\:text-red-500:hover{color:var(--color-red-500)}.hover\\:text-red-600:hover{color:var(--color-red-600)}.hover\\:text-red-700:hover{color:var(--color-red-700)}.hover\\:text-white:hover{color:var(--color-white)}.hover\\:underline:hover{text-decoration-line:underline}.hover\\:opacity-100:hover{opacity:1}.hover\\:shadow-md:hover{--tw-shadow:0 4px 6px -1px var(--tw-shadow-color,#0000001a),0 2px 4px -2px var(--tw-shadow-color,#0000001a);box-shadow:var(--tw-inset-shadow),var(--tw-inset-ring-shadow),var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow)}.hover\\:shadow-sm:hover{--tw-shadow:0 1px 3px 0 var(--tw-shadow-color,#0000001a),0 1px 2px -1px var(--tw-shadow-color,#0000001a);box-shadow:var(--tw-inset-shadow),var(--tw-inset-ring-shadow),var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow)}}.focus\\:border-blue-500:focus{border-color:var(--color-blue-500)}.focus\\:border-brilliant-azure-500:focus{border-color:var(--color-brilliant-azure-500)}.focus\\:border-red-500:focus{border-color:var(--color-red-500)}.focus\\:ring-2:focus{--tw-ring-shadow:var(--tw-ring-inset, )0 0 0 calc(2px + var(--tw-ring-offset-width))var(--tw-ring-color,currentcolor);box-shadow:var(--tw-inset-shadow),var(--tw-inset-ring-shadow),var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow)}.focus\\:ring-blue-500:focus{--tw-ring-color:var(--color-blue-500)}.focus\\:ring-brilliant-azure-500:focus{--tw-ring-color:var(--color-brilliant-azure-500)}.focus\\:ring-graphite-500:focus{--tw-ring-color:var(--color-graphite-500)}.focus\\:ring-gray-500:focus{--tw-ring-color:var(--color-gray-500)}.focus\\:ring-green-500:focus{--tw-ring-color:var(--color-green-500)}.focus\\:ring-ink-black-400:focus{--tw-ring-color:var(--color-ink-black-400)}.focus\\:ring-red-500:focus{--tw-ring-color:var(--color-red-500)}.focus\\:ring-yellow-500:focus{--tw-ring-color:var(--color-yellow-500)}.focus\\:ring-offset-2:focus{--tw-ring-offset-width:2px;--tw-ring-offset-shadow:var(--tw-ring-inset, )0 0 0 var(--tw-ring-offset-width)var(--tw-ring-offset-color)}.focus\\:outline-none:focus{--tw-outline-style:none;outline-style:none}.focus\\:invalid\\:border-red-500:focus:invalid{border-color:var(--color-red-500)}.focus\\:invalid\\:ring-red-500:focus:invalid{--tw-ring-color:var(--color-red-500)}.active\\:scale-95:active{--tw-scale-x:95%;--tw-scale-y:95%;--tw-scale-z:95%;scale:var(--tw-scale-x)var(--tw-scale-y)}.disabled\\:cursor-not-allowed:disabled{cursor:not-allowed}.disabled\\:bg-gray-100:disabled{background-color:var(--color-gray-100)}.disabled\\:text-gray-500:disabled{color:var(--color-gray-500)}@media (width>=40rem){.sm\\:col-span-2{grid-column:span 2/span 2}.sm\\:flex{display:flex}.sm\\:grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.sm\\:flex-row{flex-direction:row}.sm\\:items-center{align-items:center}.sm\\:px-6{padding-inline:calc(var(--spacing)*6)}.sm\\:text-sm{font-size:var(--text-sm);line-height:var(--tw-leading,var(--text-sm--line-height))}.sm\\:opacity-0{opacity:0}}@media (width>=48rem){.md\\:static{position:static}.md\\:col-span-2{grid-column:span 2/span 2}.md\\:col-span-4{grid-column:span 4/span 4}.md\\:col-span-6{grid-column:span 6/span 6}.md\\:col-span-10{grid-column:span 10/span 10}.md\\:col-span-12{grid-column:span 12/span 12}.md\\:mt-0{margin-top:calc(var(--spacing)*0)}.md\\:block{display:block}.md\\:flex{display:flex}.md\\:grid{display:grid}.md\\:hidden{display:none}.md\\:w-1\\/2{width:50%}.md\\:w-\\[200px\\]{width:200px}.md\\:w-full{width:100%}.md\\:flex-initial{flex:0 auto}.md\\:translate-x-0{--tw-translate-x:calc(var(--spacing)*0);translate:var(--tw-translate-x)var(--tw-translate-y)}.md\\:grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.md\\:grid-cols-3{grid-template-columns:repeat(3,minmax(0,1fr))}.md\\:grid-cols-12{grid-template-columns:repeat(12,minmax(0,1fr))}.md\\:flex-row{flex-direction:row}.md\\:items-center{align-items:center}:where(.md\\:divide-x>:not(:last-child)){--tw-divide-x-reverse:0;border-inline-style:var(--tw-border-style);border-inline-start-width:calc(1px*var(--tw-divide-x-reverse));border-inline-end-width:calc(1px*calc(1 - var(--tw-divide-x-reverse)))}:where(.md\\:divide-y-0>:not(:last-child)){--tw-divide-y-reverse:0;border-bottom-style:var(--tw-border-style);border-top-style:var(--tw-border-style);border-top-width:calc(0px*var(--tw-divide-y-reverse));border-bottom-width:calc(0px*calc(1 - var(--tw-divide-y-reverse)))}.md\\:px-4{padding-inline:calc(var(--spacing)*4)}.md\\:transition-none{transition-property:none}}@media (width>=64rem){.lg\\:flex{display:flex}.lg\\:hidden{display:none}.lg\\:max-w-\\[320px\\]{max-width:320px}.lg\\:grid-cols-2{grid-template-columns:repeat(2,minmax(0,1fr))}.lg\\:grid-cols-3{grid-template-columns:repeat(3,minmax(0,1fr))}.lg\\:flex-row{flex-direction:row}.lg\\:items-end{align-items:flex-end}.lg\\:border-t-0{border-top-style:var(--tw-border-style);border-top-width:0}.lg\\:border-l{border-left-style:var(--tw-border-style);border-left-width:1px}.lg\\:p-4{padding:calc(var(--spacing)*4)}.lg\\:px-8{padding-inline:calc(var(--spacing)*8)}}.\\[\\&\\:\\:-webkit-scrollbar\\]\\:w-\\[4px\\]::-webkit-scrollbar{width:4px}.\\[\\&\\:\\:-webkit-scrollbar-thumb\\]\\:rounded-full::-webkit-scrollbar-thumb{border-radius:3.40282e38px}.\\[\\&\\:\\:-webkit-scrollbar-thumb\\]\\:bg-gray-200::-webkit-scrollbar-thumb{background-color:var(--color-gray-200)}.\\[\\&\\:\\:-webkit-scrollbar-track\\]\\:bg-transparent::-webkit-scrollbar-track{background-color:#0000}.\\[\\&\\:has\\(\\~\\.prefix-slot\\[name\\=prefix\\]\\)\\:not\\(\\:placeholder-shown\\)\\]\\:pl-10:has(~.prefix-slot[name=prefix]):not(:placeholder-shown){padding-left:calc(var(--spacing)*10)}.\\[\\&\\:has\\(\\~\\.suffix-slot\\[name\\=action\\]\\)\\]\\:pr-10:has(~.suffix-slot[name=action]){padding-right:calc(var(--spacing)*10)}.\\[\\&\\>sidebar-item\\:first-of-type\\]\\:font-bold>sidebar-item:first-of-type{--tw-font-weight:var(--font-weight-bold);font-weight:var(--font-weight-bold)}.\\[\\&\\>sidebar-item\\:first-of-type\\]\\:text-ink-black-500>sidebar-item:first-of-type{color:var(--color-ink-black-500)}}@property --tw-translate-x{syntax:\"*\";inherits:false;initial-value:0}@property --tw-translate-y{syntax:\"*\";inherits:false;initial-value:0}@property --tw-translate-z{syntax:\"*\";inherits:false;initial-value:0}@property --tw-rotate-x{syntax:\"*\";inherits:false}@property --tw-rotate-y{syntax:\"*\";inherits:false}@property --tw-rotate-z{syntax:\"*\";inherits:false}@property --tw-skew-x{syntax:\"*\";inherits:false}@property --tw-skew-y{syntax:\"*\";inherits:false}@property --tw-space-y-reverse{syntax:\"*\";inherits:false;initial-value:0}@property --tw-divide-x-reverse{syntax:\"*\";inherits:false;initial-value:0}@property --tw-border-style{syntax:\"*\";inherits:false;initial-value:solid}@property --tw-divide-y-reverse{syntax:\"*\";inherits:false;initial-value:0}@property --tw-gradient-position{syntax:\"*\";inherits:false}@property --tw-gradient-from{syntax:\"<color>\";inherits:false;initial-value:#0000}@property --tw-gradient-via{syntax:\"<color>\";inherits:false;initial-value:#0000}@property --tw-gradient-to{syntax:\"<color>\";inherits:false;initial-value:#0000}@property --tw-gradient-stops{syntax:\"*\";inherits:false}@property --tw-gradient-via-stops{syntax:\"*\";inherits:false}@property --tw-gradient-from-position{syntax:\"<length-percentage>\";inherits:false;initial-value:0%}@property --tw-gradient-via-position{syntax:\"<length-percentage>\";inherits:false;initial-value:50%}@property --tw-gradient-to-position{syntax:\"<length-percentage>\";inherits:false;initial-value:100%}@property --tw-leading{syntax:\"*\";inherits:false}@property --tw-font-weight{syntax:\"*\";inherits:false}@property --tw-tracking{syntax:\"*\";inherits:false}@property --tw-shadow{syntax:\"*\";inherits:false;initial-value:0 0 #0000}@property --tw-shadow-color{syntax:\"*\";inherits:false}@property --tw-shadow-alpha{syntax:\"<percentage>\";inherits:false;initial-value:100%}@property --tw-inset-shadow{syntax:\"*\";inherits:false;initial-value:0 0 #0000}@property --tw-inset-shadow-color{syntax:\"*\";inherits:false}@property --tw-inset-shadow-alpha{syntax:\"<percentage>\";inherits:false;initial-value:100%}@property --tw-ring-color{syntax:\"*\";inherits:false}@property --tw-ring-shadow{syntax:\"*\";inherits:false;initial-value:0 0 #0000}@property --tw-inset-ring-color{syntax:\"*\";inherits:false}@property --tw-inset-ring-shadow{syntax:\"*\";inherits:false;initial-value:0 0 #0000}@property --tw-ring-inset{syntax:\"*\";inherits:false}@property --tw-ring-offset-width{syntax:\"<length>\";inherits:false;initial-value:0}@property --tw-ring-offset-color{syntax:\"*\";inherits:false;initial-value:#fff}@property --tw-ring-offset-shadow{syntax:\"*\";inherits:false;initial-value:0 0 #0000}@property --tw-outline-style{syntax:\"*\";inherits:false;initial-value:solid}@property --tw-blur{syntax:\"*\";inherits:false}@property --tw-brightness{syntax:\"*\";inherits:false}@property --tw-contrast{syntax:\"*\";inherits:false}@property --tw-grayscale{syntax:\"*\";inherits:false}@property --tw-hue-rotate{syntax:\"*\";inherits:false}@property --tw-invert{syntax:\"*\";inherits:false}@property --tw-opacity{syntax:\"*\";inherits:false}@property --tw-saturate{syntax:\"*\";inherits:false}@property --tw-sepia{syntax:\"*\";inherits:false}@property --tw-drop-shadow{syntax:\"*\";inherits:false}@property --tw-drop-shadow-color{syntax:\"*\";inherits:false}@property --tw-drop-shadow-alpha{syntax:\"<percentage>\";inherits:false;initial-value:100%}@property --tw-drop-shadow-size{syntax:\"*\";inherits:false}@property --tw-backdrop-blur{syntax:\"*\";inherits:false}@property --tw-backdrop-brightness{syntax:\"*\";inherits:false}@property --tw-backdrop-contrast{syntax:\"*\";inherits:false}@property --tw-backdrop-grayscale{syntax:\"*\";inherits:false}@property --tw-backdrop-hue-rotate{syntax:\"*\";inherits:false}@property --tw-backdrop-invert{syntax:\"*\";inherits:false}@property --tw-backdrop-opacity{syntax:\"*\";inherits:false}@property --tw-backdrop-saturate{syntax:\"*\";inherits:false}@property --tw-backdrop-sepia{syntax:\"*\";inherits:false}@property --tw-duration{syntax:\"*\";inherits:false}@property --tw-ease{syntax:\"*\";inherits:false}@property --tw-scale-x{syntax:\"*\";inherits:false;initial-value:1}@property --tw-scale-y{syntax:\"*\";inherits:false;initial-value:1}@property --tw-scale-z{syntax:\"*\";inherits:false;initial-value:1}@keyframes spin{to{transform:rotate(360deg)}}";

});


parcelRegister("djfoQ", function(module, exports) {

$parcel$export(module.exports, "sessionChannel", () => $9b08fec8dc8abf2d$export$c7d51c4d1d0dc189);
$parcel$export(module.exports, "contextChannel", () => $9b08fec8dc8abf2d$export$cb03dd77c6bdb07c);
$parcel$export(module.exports, "notificationChannel", () => $9b08fec8dc8abf2d$export$480f4921faebd04a);
$parcel$export(module.exports, "uiChannel", () => $9b08fec8dc8abf2d$export$11dece4ba9757aa5);
$parcel$export(module.exports, "showLoader", () => $9b08fec8dc8abf2d$export$56525cbb1fcd885c);
$parcel$export(module.exports, "hideLoader", () => $9b08fec8dc8abf2d$export$5cee2c2772922923);
$parcel$export(module.exports, "productFormChannel", () => $9b08fec8dc8abf2d$export$3ad78e366bdd075c);
$parcel$export(module.exports, "notify", () => $9b08fec8dc8abf2d$export$5e14cdade93d6f7b);
$parcel$export(module.exports, "hasFeature", () => $9b08fec8dc8abf2d$export$805ddaeeece0413e);
$parcel$export(module.exports, "hasIACredits", () => $9b08fec8dc8abf2d$export$953bdf2068586f53);
$parcel$export(module.exports, "hasLimitAvailable", () => $9b08fec8dc8abf2d$export$2a0139c0bf7fedf4);
$parcel$export(module.exports, "SUPPORTED_LANGUAGES", () => $9b08fec8dc8abf2d$export$7c77c3a9bb93870d);
$parcel$export(module.exports, "setLanguage", () => $9b08fec8dc8abf2d$export$4b6bf64406ec64af);
$parcel$export(module.exports, "getLanguageName", () => $9b08fec8dc8abf2d$export$b2c54cc5f2ff61e9);

var $9sPXe = parcelRequire("9sPXe");
const $9b08fec8dc8abf2d$var$app = new (0, $9sPXe.default)();
const $9b08fec8dc8abf2d$export$c7d51c4d1d0dc189 = $9b08fec8dc8abf2d$var$app.factory('session', {
    user: null,
    token: null,
    isAuthenticated: false
});
const $9b08fec8dc8abf2d$export$cb03dd77c6bdb07c = $9b08fec8dc8abf2d$var$app.factory('context', {
    branchId: null,
    lang: 'es'
});
const $9b08fec8dc8abf2d$export$480f4921faebd04a = $9b08fec8dc8abf2d$var$app.factory('notifications', null);
const $9b08fec8dc8abf2d$export$11dece4ba9757aa5 = $9b08fec8dc8abf2d$var$app.factory('ui', {
    isSidebarOpen: false,
    isContextDrawerOpen: false,
    isLoading: false,
    loaderMessage: ''
});
const $9b08fec8dc8abf2d$export$56525cbb1fcd885c = (message = 'Cargando...')=>{
    $9b08fec8dc8abf2d$export$11dece4ba9757aa5.send((state)=>({
            ...state,
            isLoading: true,
            loaderMessage: message
        }));
};
const $9b08fec8dc8abf2d$export$5cee2c2772922923 = ()=>{
    $9b08fec8dc8abf2d$export$11dece4ba9757aa5.send((state)=>({
            ...state,
            isLoading: false,
            loaderMessage: ''
        }));
};
const $9b08fec8dc8abf2d$export$3ad78e366bdd075c = $9b08fec8dc8abf2d$var$app.factory('productForm', {
    modifierType: 'simple'
});
const $9b08fec8dc8abf2d$export$5e14cdade93d6f7b = (message, type = 'info')=>{
    $9b08fec8dc8abf2d$export$480f4921faebd04a.send({
        id: Date.now(),
        message: message,
        type: type
    });
};
const $9b08fec8dc8abf2d$export$805ddaeeece0413e = (featureName)=>{
    const session = $9b08fec8dc8abf2d$export$c7d51c4d1d0dc189.value;
    return session?.subscription?.features?.[featureName] === true;
};
const $9b08fec8dc8abf2d$export$953bdf2068586f53 = (iaActionName)=>{
    const session = $9b08fec8dc8abf2d$export$c7d51c4d1d0dc189.value;
    const remaining = session?.subscription?.ia?.remaining || 0;
    const cost = session?.subscription?.ia?.costs?.[iaActionName] || 1;
    return remaining >= cost;
};
const $9b08fec8dc8abf2d$export$2a0139c0bf7fedf4 = (limitName)=>{
    const session = $9b08fec8dc8abf2d$export$c7d51c4d1d0dc189.value;
    const limit = session?.subscription?.limits?.[limitName];
    const usage = session?.subscription?.usage?.[limitName] || 0;
    // Si no existe el límite definido o es ilimitado (-1)
    if (limit === undefined || limit === -1) return true;
    return limit > usage;
};
const $9b08fec8dc8abf2d$export$7c77c3a9bb93870d = {
    es: {
        name: "Espa\xf1ol",
        flag: "\uD83C\uDDF2\uD83C\uDDFD"
    },
    en: {
        name: 'English',
        flag: "\uD83C\uDDFA\uD83C\uDDF8"
    },
    it: {
        name: 'Italiano',
        flag: "\uD83C\uDDEE\uD83C\uDDF9"
    },
    fr: {
        name: "Fran\xe7ais",
        flag: "\uD83C\uDDEB\uD83C\uDDF7"
    },
    de: {
        name: 'Deutsch',
        flag: "\uD83C\uDDE9\uD83C\uDDEA"
    },
    ru: {
        name: "\u0420\u0443\u0441\u0441\u043A\u0438\u0439",
        flag: "\uD83C\uDDF7\uD83C\uDDFA"
    },
    pt: {
        name: "Portugu\xeas",
        flag: "\uD83C\uDDE7\uD83C\uDDF7"
    }
};
const $9b08fec8dc8abf2d$export$4b6bf64406ec64af = (lang)=>{
    if (!$9b08fec8dc8abf2d$export$7c77c3a9bb93870d[lang]) {
        console.warn(`Idioma no soportado: ${lang}`);
        return;
    }
    $9b08fec8dc8abf2d$export$cb03dd77c6bdb07c.send((state)=>({
            ...state,
            lang: lang
        }));
    localStorage.setItem('_lang', lang);
};
const $9b08fec8dc8abf2d$export$b2c54cc5f2ff61e9 = (lang = null)=>{
    const targetLang = lang || $9b08fec8dc8abf2d$export$cb03dd77c6bdb07c.value?.lang || 'es';
    return $9b08fec8dc8abf2d$export$7c77c3a9bb93870d[targetLang]?.name || "Espa\xf1ol";
};
const $9b08fec8dc8abf2d$export$544ea8661fa0df65 = ()=>{
    const savedLang = localStorage.getItem('_lang');
    if (savedLang && $9b08fec8dc8abf2d$export$7c77c3a9bb93870d[savedLang]) $9b08fec8dc8abf2d$export$cb03dd77c6bdb07c.send((state)=>({
            ...state,
            lang: savedLang
        }));
};

});
parcelRegister("9sPXe", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e3f07a56e217d45$export$2e2bcd8739ae039);
class $6e3f07a56e217d45$export$6363f72201106843 {
    #t = new WeakMap;
    #n = new Map;
    constructor(){
        this.plugins = [];
    }
    use(t) {
        return this.plugins.push(t), t(this), this;
    }
    factory(t, e, n = {}) {
        if (typeof t == "string" && n.public) {
            const s = Symbol.for(`helium:public:${t}`);
            return globalThis[s] || (globalThis[s] = this.createChannel(e)), globalThis[s];
        }
        return typeof t == "string" ? (this.#n.has(t) || this.#n.set(t, this.createChannel(e)), this.#n.get(t)) : typeof t == "function" && arguments.length === 1 ? this.action(t) : (typeof t == "object" || typeof t == "function") && t !== null ? Object.getPrototypeOf(t) === Object.prototype && arguments.length === 1 ? this.createChannel(t) : (this.#t.has(t) || this.#t.set(t, this.createChannel(e)), this.#t.get(t)) : this.createChannel(e);
    }
    createChannel(t) {
        const e = new Set;
        return {
            value: t,
            send (n) {
                const s = typeof n == "function" ? n(this.value) : n;
                if (this.value !== s) {
                    this.value = s;
                    for (const i of e)i(s);
                }
            },
            on (n) {
                return e.add(n), n(this.value), ()=>e.delete(n);
            },
            bind (n, s) {
                s(n, this.value);
                const i = (a)=>{
                    if (!n.isConnected) {
                        e.delete(i);
                        return;
                    }
                    s(n, a);
                };
                return e.add(i), ()=>e.delete(i);
            },
            silent (n) {
                this.value = n;
            }
        };
    }
    action(t) {
        const e = this.createChannel({
            data: null,
            loading: !1,
            error: null
        });
        let n = null;
        return e.run = async (...s)=>{
            n && n.abort(), n = new AbortController;
            const { signal: i } = n;
            e.send((a)=>({
                    ...a,
                    loading: !0,
                    error: null
                }));
            try {
                const a = await t({
                    signal: i,
                    args: s
                });
                i.aborted || e.send({
                    data: a,
                    loading: !1,
                    error: null
                });
            } catch (a) {
                !i.aborted && a.name !== "AbortError" && e.send((l)=>({
                        ...l,
                        loading: !1,
                        error: a.message || a
                    }));
            }
        }, e;
    }
}
var $6e3f07a56e217d45$export$2e2bcd8739ae039 = $6e3f07a56e217d45$export$6363f72201106843;

});


parcelRegister("dkmhp", function(module, exports) {

$parcel$export(module.exports, "api", () => $9b3e6cedef55f70c$export$644d8ea042df96a6);
/**
 * Base API service for the Admin Panel.
 * Handles fetch requests, headers, and unified error handling.
 */ 
var $gnjKo = parcelRequire("gnjKo");

var $djfoQ = parcelRequire("djfoQ");
const $9b3e6cedef55f70c$var$host = (0, $gnjKo.config).host;

class $9b3e6cedef55f70c$var$ApiService {
    #isRedirecting = false;
    /**
     * Generic fetch wrapper
     * @param {string} url - Full URL or endpoint
     * @param {object} options - Fetch options
     */ async request(url, options = {}) {
        // Si la URL no tiene http, asumimos que es relativa al host
        const fullUrl = url.startsWith('http') ? url : `${$9b3e6cedef55f70c$var$host}${url.startsWith('/') ? '' : '/'}${url}`;
        const token = sessionStorage.getItem('authToken') || localStorage.getItem('authToken');
        const isFormData = options.body instanceof FormData;
        const defaultHeaders = {
            ...isFormData ? {} : {
                'Content-Type': 'application/json'
            },
            ...token ? {
                'Authorization': `Bearer ${token}`
            } : {}
        };
        const fetchConfig = {
            ...options,
            headers: {
                ...defaultHeaders,
                ...options.headers
            }
        };
        try {
            const response = await fetch(fullUrl, fetchConfig);
            // Intentamos parsear, si falla (204 No Content), devolvemos objeto vacío
            const data = await response.json().catch(()=>({}));
            if (!response.ok) {
                // Guardian de Sesión: Si el error es por falta de autorización, cerramos sesión
                if (data.message?.startsWith('auth.unauthorized') && !this.#isRedirecting) {
                    this.#isRedirecting = true;
                    (0, $djfoQ.notify)("Sesi\xf3n inv\xe1lida, saliendo del sistema...", 'error');
                    setTimeout(async ()=>{
                        sessionStorage.clear();
                        localStorage.removeItem('authToken');
                        localStorage.removeItem('_b');
                        (0, $djfoQ.sessionChannel).send({
                            user: null,
                            token: null,
                            isAuthenticated: false,
                            subscription: null
                        });
                        const { contextChannel: ctx } = await Promise.resolve((parcelRequire("djfoQ")));
                        ctx.send({
                            branchId: null
                        });
                        this.#isRedirecting = false;
                    }, 6000);
                }
                const error = new Error(data.message || "Error en la petici\xf3n");
                error.status = response.status;
                error.data = data;
                throw error;
            }
            return data;
        } catch (error) {
            console.error(`[API Error] ${url}:`, error);
            throw error;
        }
    }
    async get(url, params = {}) {
        // Simple query string builder
        const queryString = new URLSearchParams(params).toString();
        const fullUrl = queryString ? `${url}?${queryString}` : url;
        return this.request(fullUrl, {
            method: 'GET'
        });
    }
    async post(url, data = {}) {
        const isFormData = data instanceof FormData;
        return this.request(url, {
            method: 'POST',
            body: isFormData ? data : JSON.stringify(data)
        });
    }
    async patch(url, data = {}) {
        return this.request(url, {
            method: 'PATCH',
            body: JSON.stringify(data)
        });
    }
    async put(url, data = {}) {
        return this.request(url, {
            method: 'PUT',
            body: JSON.stringify(data)
        });
    }
    async delete(url) {
        return this.request(url, {
            method: 'DELETE'
        });
    }
}
const $9b3e6cedef55f70c$export$644d8ea042df96a6 = new $9b3e6cedef55f70c$var$ApiService();

});
parcelRegister("gnjKo", function(module, exports) {

$parcel$export(module.exports, "config", () => $bebe1cbb5a309c8c$export$e506a1d27d1eaa20);
// Centralized configuration for the Admin Panel
const $bebe1cbb5a309c8c$export$e506a1d27d1eaa20 = {
    env: "production",
    // En producción y desarrollo usamos rutas relativas para que el Proxy inverso maneje el ruteo.
    // El proxy de desarrollo de Parcel o Traefik redirigirá /api hacia el backend.
    host: '',
    appName: "QR Smart Menu Panel",
    isDev: false
};
// Expose to window for debugging purposes
window.appConfig = $bebe1cbb5a309c8c$export$e506a1d27d1eaa20;

});


parcelRegister("pcvPw", function(module, exports) {

var $47uWi = parcelRequire("47uWi");

var $1UDf4 = parcelRequire("1UDf4");
const $04bc0a9cfc76b06c$var$VARIANTS = {
    info: 'bg-blue-50 text-blue-800',
    warning: 'bg-amber-50 text-amber-800',
    danger: 'bg-red-50 text-red-800',
    success: 'bg-green-50 text-green-800'
};
const $04bc0a9cfc76b06c$var$template = (0, $47uWi.FlowComponent).html`
    <div id="container" class="flex items-center justify-between p-3 px-5 w-full gap-4 leading-tight font-medium text-sm" role="alert">
        <div class="flex items-center gap-3 flex-1">
            <span class="text-xl flex-shrink-0">${'icon'}</span>
            <div class="flex-1">
                <span>${'message'}</span>
                <slot></slot>
            </div>
        </div>
        <button id="closeBtn" class="text-xl opacity-60 hover:opacity-100 transition-opacity p-1 leading-none" aria-label="Cerrar">
            🗙
        </button>
    </div>
`;
class $04bc0a9cfc76b06c$export$92a2ba1bcd1d2975 extends (0, $47uWi.FlowComponent) {
    static get styles() {
        return 0, $1UDf4.default;
    }
    static get template() {
        return $04bc0a9cfc76b06c$var$template;
    }
    onMount() {
        super.onMount();
        this.#applyVariant();
        this.root.querySelector('#closeBtn').onclick = ()=>{
            this.dispatchEvent(new CustomEvent('banner:closed', {
                bubbles: true,
                composed: true
            }));
            this.remove();
        };
    }
    #applyVariant() {
        const variant = this.getAttribute('variant') || 'info';
        const container = this.root.getElementById('container');
        if (container) {
            const classes = $04bc0a9cfc76b06c$var$VARIANTS[variant] || $04bc0a9cfc76b06c$var$VARIANTS.info;
            container.className = `flex items-center justify-between p-3 px-5 w-full gap-4 leading-tight font-medium text-sm ${classes}`;
        }
    }
}
customElements.define('flow-banner', $04bc0a9cfc76b06c$export$92a2ba1bcd1d2975);

});
parcelRegister("1UDf4", function(module, exports) {

$parcel$export(module.exports, "default", () => $1649760c2b9c1443$export$2e2bcd8739ae039);

var $kaZmj = parcelRequire("kaZmj");
const $1649760c2b9c1443$var$styles = new CSSStyleSheet();
$1649760c2b9c1443$var$styles.replaceSync(`
    :host {
        display: block;
        width: 100%;
    }
`);
var $1649760c2b9c1443$export$2e2bcd8739ae039 = [
    (0, $kaZmj.tailwindSheet),
    (0, $kaZmj.baseStyles),
    $1649760c2b9c1443$var$styles
];

});


parcelRegister("7n9n0", function(module, exports) {

var $47uWi = parcelRequire("47uWi");

var $iP7JA = parcelRequire("iP7JA");

var $djfoQ = parcelRequire("djfoQ");
const $55e1f316878bc387$var$template = (0, $47uWi.FlowComponent).html`
    <div class="lock-wrapper">
        <div id="content" class="locked-content">
            <slot></slot>
        </div>
        <div id="overlay" class="overlay"></div>
        <div id="badge" class="badge-container"></div>
    </div>
`;
class $55e1f316878bc387$export$8aa0d4374f7197e5 extends (0, $47uWi.FlowComponent) {
    static get styles() {
        return 0, $iP7JA.default;
    }
    static get template() {
        return $55e1f316878bc387$var$template;
    }
    onMount() {
        super.onMount();
        // Evaluamos cuando hay cambios en la suscripción
        (0, $djfoQ.sessionChannel).bind(this, ()=>{
            this.#evaluateAccess();
        });
        // Manejador del click para la alerta
        const overlay = this.root.getElementById('overlay');
        overlay.addEventListener('click', (e)=>{
            e.preventDefault();
            e.stopPropagation();
            this.#handleLockedClick();
        });
        // Si es inline, permitimos que el click en el badge también dispare la alerta
        const badge = this.root.getElementById('badge');
        badge.style.pointerEvents = 'auto'; // Permitir clicks en el badge
        badge.addEventListener('click', (e)=>{
            if (badge.style.display !== 'none') {
                e.preventDefault();
                e.stopPropagation();
                this.#handleLockedClick();
            }
        });
    }
    #getBadgeHTML(level, lockType) {
        let text = `requiere ${level}`;
        let icon = `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>`;
        if (lockType === 'credits') {
            text = 'requiere ia';
            icon = "\u2728";
        } else if (lockType === 'limit') {
            text = "l\xedmite alcanzado";
            icon = "\uD83D\uDCC8";
        }
        let levelClass = level === 'plus' ? 'level-plus' : 'level-pro';
        if (lockType === 'credits') levelClass = 'level-credits';
        return `
            <span class="lock-badge ${levelClass}" title="Funci\xf3n restringida">
                <span>${text}</span>
                ${icon}
            </span>
        `;
    }
    #evaluateAccess() {
        const oldFeature = this.getAttribute('feature');
        const oldIaAction = this.getAttribute('ia-action');
        let lockType = this.getAttribute('lock-type');
        let lockKey = this.getAttribute('lock-key');
        let level = this.getAttribute('level') || 'pro';
        // Backwards compatibility
        if (!lockType) {
            if (oldIaAction) {
                lockType = 'credits';
                lockKey = oldIaAction;
            } else if (oldFeature) {
                lockType = 'feature';
                lockKey = oldFeature;
            } else lockType = 'feature';
        }
        let hasAccess = true;
        if (lockType === 'feature' && lockKey) hasAccess = (0, $djfoQ.hasFeature)(lockKey);
        else if (lockType === 'credits' && lockKey) hasAccess = (0, $djfoQ.hasIACredits)(lockKey);
        else if (lockType === 'limit' && lockKey) hasAccess = (0, $djfoQ.hasLimitAvailable)(lockKey);
        const content = this.root.getElementById('content');
        const overlay = this.root.getElementById('overlay');
        const badge = this.root.getElementById('badge');
        // Si no hay hijos en el slot, no atenuamos nada ni mostramos overlay
        const hasChildren = this.childNodes.length > 0;
        if (hasAccess) {
            content.classList.remove('locked-content');
            overlay.style.display = 'none';
            badge.style.display = 'none';
        } else {
            if (hasChildren) {
                content.classList.add('locked-content');
                overlay.style.display = 'block';
            } else {
                content.classList.remove('locked-content');
                overlay.style.display = 'none';
            }
            badge.style.display = 'block';
            badge.innerHTML = this.#getBadgeHTML(level, lockType);
        }
    }
    #handleLockedClick() {
        let defaultMessage = "Esta funci\xf3n es exclusiva. Mejora tu plan a PRO para acceder a ella.";
        const lockType = this.getAttribute('lock-type');
        const level = this.getAttribute('level') || 'pro';
        const oldIaAction = this.getAttribute('ia-action');
        if (lockType === 'credits' || oldIaAction) defaultMessage = "No tienes suficientes cr\xe9ditos de IA para realizar esta acci\xf3n. Adquiere m\xe1s cr\xe9ditos o mejora tu plan.";
        else if (lockType === 'limit') defaultMessage = "Has alcanzado el l\xedmite de tu plan para este recurso. Mejora tu suscripci\xf3n para ampliar tus l\xedmites.";
        else if (level === 'plus') defaultMessage = "Esta funci\xf3n requiere el plan PLUS. Mejora tu suscripci\xf3n para desbloquearla.";
        const message = this.getAttribute('message') || defaultMessage;
        // Mostramos el Toast/Callout
        (0, $djfoQ.notify)(message, 'info');
    }
}
customElements.define('flow-feature-lock', $55e1f316878bc387$export$8aa0d4374f7197e5);

});
parcelRegister("iP7JA", function(module, exports) {

$parcel$export(module.exports, "default", () => $db42fd43859faa56$export$2e2bcd8739ae039);
const $db42fd43859faa56$var$sheet = new CSSStyleSheet();
$db42fd43859faa56$var$sheet.replaceSync(`
    :host {
        display: block;
        position: relative;
    }
    
    .lock-wrapper {
        position: relative;
        display: inline-block;
        width: 100%;
    }
    
    .locked-content {
        opacity: 0.6;
        pointer-events: none;
        user-select: none;
        transition: opacity 0.2s ease;
    }
    
    .overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 10;
        cursor: pointer;
    }
    
    .badge-container {
        position: absolute;
        top: -10px;
        right: -10px;
        z-index: 20;
        pointer-events: none;
    }
    
    .lock-badge {
        display: inline-flex;
        align-items: center;
        gap: 0.25rem;
        padding: 0.125rem 0.5rem;
        font-size: 0.75rem;
        font-weight: 600;
        border-radius: 9999px;
        box-shadow: 0 1px 2px rgba(0,0,0,0.05);
        border: 1px solid transparent;
        white-space: nowrap;
        text-transform: lowercase;
    }
    
    .level-pro {
        background-color: var(--color-green-100, #dcfce7);
        color: var(--color-green-700, #15803d);
        border-color: var(--color-green-200, #bbf7d0);
    }
    
    .level-plus {
        background-color: var(--color-blue-100, #dbeafe);
        color: var(--color-blue-700, #1d4ed8);
        border-color: var(--color-blue-200, #bfdbfe);
    }

    .level-credits {
        background-color: var(--color-yellow-100, #fef9c3);
        color: var(--color-yellow-700, #a16207);
        border-color: var(--color-yellow-200, #fef08a);
    }
    
    /* Para cuando el badge se muestra junto al label si se define como 'inline' */
    :host([inline]) .lock-wrapper {
        display: inline-flex;
        align-items: center;
        gap: 0.5rem;
    }
    
    :host([inline]) .badge-container {
        position: relative;
        top: 0;
        right: 0;
    }

    /* Para cuando necesitamos que el contenedor se ajuste al contenido (ej. botones) */
    :host([inline-block]) {
        display: inline-block;
    }
    
    :host([inline-block]) .lock-wrapper {
        width: auto;
    }
`);
var $db42fd43859faa56$export$2e2bcd8739ae039 = $db42fd43859faa56$var$sheet;

});


parcelRegister("9mMsU", function(module, exports) {
module.exports = Promise.all([
    import("6071N"),
    import("2rLcq")
]).then(()=>parcelRequire('aMkuD'));

});

parcelRegister("b8DRw", function(module, exports) {
module.exports = Promise.all([
    import("dw2YI"),
    import("chUht")
]).then(()=>parcelRequire('dSOgK'));

});

parcelRegister("63DoA", function(module, exports) {
module.exports = import("kNq5v").then(()=>parcelRequire('lSMvy'));

});

parcelRegister("k9Ih6", function(module, exports) {

var $47uWi = parcelRequire("47uWi");

var $jaLfq = parcelRequire("jaLfq");
const $eac6fdf5a65fc45c$var$template = (0, $47uWi.FlowComponent).html`
    <button type="${'type'}" class="w-full flex items-center justify-center border border-transparent font-bold transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 ${'variant-class'}">
        <slot></slot>
        <span class="label-text">${'label'}</span>
        <slot name="icon"></slot>
    </button>
`;
class $eac6fdf5a65fc45c$export$5ecd39bbfa811519 extends (0, $47uWi.FlowComponent) {
    static get styles() {
        return 0, $jaLfq.default;
    }
    static get template() {
        return $eac6fdf5a65fc45c$var$template;
    }
    static get observedAttributes() {
        return [
            'variant',
            'type',
            'label',
            'loading',
            'small',
            'big',
            'light',
            'dark',
            'flat',
            'variant-class',
            'w-auto'
        ];
    }
    // Mapas de estilos completos para asegurar que Tailwind genere las clases
    #styleMap = {
        primary: {
            default: 'bg-brilliant-azure-500 hover:bg-brilliant-azure-600 text-white focus:ring-brilliant-azure-500',
            light: 'bg-brilliant-azure-100 hover:bg-brilliant-azure-200 text-brilliant-azure-800 focus:ring-brilliant-azure-500',
            dark: 'bg-ink-black-400 hover:bg-ink-black-500 text-white focus:ring-ink-black-400'
        },
        secondary: {
            default: 'bg-graphite-500 hover:bg-graphite-600 text-white focus:ring-graphite-500',
            light: 'bg-graphite-100 hover:bg-graphite-200 text-graphite-800 focus:ring-graphite-500',
            dark: 'bg-graphite-800 hover:bg-graphite-900 text-white focus:ring-graphite-500'
        },
        danger: {
            default: 'bg-red-600 hover:bg-red-700 text-white focus:ring-red-500',
            light: 'bg-red-100 hover:bg-red-200 text-red-800 focus:ring-red-500',
            dark: 'bg-red-800 hover:bg-red-900 text-white focus:ring-red-500'
        },
        success: {
            default: 'bg-green-600 hover:bg-green-700 text-white focus:ring-green-500',
            light: 'bg-green-100 hover:bg-green-200 text-green-800 focus:ring-green-500',
            dark: 'bg-green-800 hover:bg-green-900 text-white focus:ring-green-500'
        },
        warning: {
            default: 'bg-yellow-600 hover:bg-yellow-700 text-white focus:ring-yellow-500',
            light: 'bg-yellow-100 hover:bg-yellow-200 text-yellow-800 focus:ring-yellow-500',
            dark: 'bg-yellow-800 hover:bg-yellow-900 text-white focus:ring-yellow-500'
        }
    };
    onMount() {
        super.onMount();
        this.#updateClasses();
    }
    onAttributeChanged(name, old, val) {
        // Reaccionamos a cualquier cambio en atributos relevantes
        if ([
            'variant',
            'small',
            'big',
            'light',
            'dark',
            'flat'
        ].includes(name)) this.#updateClasses();
        if (name === 'loading') this.#toggleLoading(val !== null);
    }
    set loading(val) {
        if (val) this.setAttribute('loading', '');
        else this.removeAttribute('loading');
    }
    get loading() {
        return this.hasAttribute('loading');
    }
    #toggleLoading(isLoading) {
        const btn = this.root.querySelector('button');
        if (!btn) return;
        if (isLoading) {
            btn.disabled = true;
            btn.classList.add('cursor-not-allowed', 'opacity-75');
            // Check if spinner already exists to avoid duplicates
            if (!this.root.querySelector('.spinner')) {
                const spinner = document.createElement('div');
                spinner.className = 'spinner mr-2';
                spinner.innerHTML = `
                    <svg class="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                `;
                btn.insertBefore(spinner, btn.firstChild);
            }
        } else {
            btn.disabled = false;
            btn.classList.remove('cursor-not-allowed', 'opacity-75');
            const spinner = this.root.querySelector('.spinner');
            if (spinner) spinner.remove();
        }
    }
    #updateClasses() {
        // 1. Resolver variante y modo
        const variant = this.getAttribute('variant') || 'primary';
        let mode = 'default';
        if (this.hasAttribute('light')) mode = 'light';
        else if (this.hasAttribute('dark')) mode = 'dark';
        // 2. Obtener clases base (Safelist implícito)
        const themeStyles = this.#styleMap[variant] || this.#styleMap['primary'];
        const colorClasses = themeStyles[mode];
        // 3. Resolver el Tamaño (Small/Big/Default)
        let sizeClasses = 'py-2 px-4 text-sm'; // Default
        if (this.hasAttribute('small')) sizeClasses = 'py-1 px-2 text-xs';
        else if (this.hasAttribute('big')) sizeClasses = 'py-3 px-6 text-base';
        // 4. Resolver la Forma (Flat/Rounded)
        const shapeClasses = this.hasAttribute('flat') ? 'rounded-none' : 'rounded-lg';
        // 5. Layout (Gap entre texto e icono)
        const layoutClasses = 'gap-2';
        // 6. Ancho (Full por defecto, o auto si se especifica)
        const widthClass = this.hasAttribute('w-auto') ? 'w-auto' : 'w-full';
        // Combinar todo
        const finalClass = `${widthClass} ${sizeClasses} ${colorClasses} ${shapeClasses} ${layoutClasses}`;
        const btn = this.root.querySelector('button');
        if (btn) btn.className = `flex items-center justify-center border border-transparent font-bold transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 ${finalClass}`;
        this.setAttribute('variant-class', finalClass);
    }
}
customElements.define('flow-button', $eac6fdf5a65fc45c$export$5ecd39bbfa811519);

});
parcelRegister("jaLfq", function(module, exports) {

$parcel$export(module.exports, "default", () => $df5399e7db70efd9$export$2e2bcd8739ae039);

var $kaZmj = parcelRequire("kaZmj");
const $df5399e7db70efd9$var$sheet = new CSSStyleSheet();
$df5399e7db70efd9$var$sheet.replaceSync(`
    :host {
        display: inline-block;
    }
    button {
        cursor: pointer;
    }
    button:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
    .label-text:empty {
        display: none;
    }
    .label-text:not(:empty) + slot[name="icon"] {
        margin-left: 0.5rem;
    }
`);
var $df5399e7db70efd9$export$2e2bcd8739ae039 = [
    (0, $kaZmj.tailwindSheet),
    (0, $kaZmj.baseStyles),
    $df5399e7db70efd9$var$sheet
];

});


parcelRegister("7Byou", function(module, exports) {

var $47uWi = parcelRequire("47uWi");

var $mcP4F = parcelRequire("mcP4F");

var $2ThBw = parcelRequire("2ThBw");
const $5896ab0407455938$var$template = (0, $47uWi.FlowComponent).html`
    <div class="mb-4 relative">
        <label class="block text-sm font-medium text-gray-700 mb-1">${'label'}</label>
        <div class="relative flex items-center w-full">
            <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-400 z-10">
                <slot name="prefix"></slot>
            </div>
            <input 
                type="${'type'}" 
                name="${'name'}" 
                placeholder="${'placeholder'}" 
                value="${'value'}"
                ?disabled="${'disabled'}"
                class="appearance-none rounded-lg relative block w-full px-3 py-3 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm invalid:border-red-500 invalid:text-red-900 focus:invalid:border-red-500 focus:invalid:ring-red-500 disabled:bg-gray-100 disabled:text-gray-500 disabled:cursor-not-allowed [&:has(~.prefix-slot[name=prefix]):not(:placeholder-shown)]:pl-10 [&:has(~.suffix-slot[name=action])]:pr-10"
            >
            <div class="password-toggle absolute inset-y-0 left-0 pl-3 flex items-center cursor-pointer text-gray-400 hover:text-gray-600 z-20" style="display: none;">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 pointer-events-none" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                </svg>
            </div>
            <div class="absolute inset-y-0 right-0 pr-2 flex items-center cursor-pointer z-10">
                <slot name="action" class="suffix-slot"></slot>
            </div>
        </div>
        <!-- Slot opcional para mensajes de error custom si no usamos los nativos -->
        <p class="mt-1 text-sm text-red-600 hidden peer-invalid:block"></p>
    </div>
`;
class $5896ab0407455938$export$21c4e83b6e5ec51 extends (0, $2ThBw.ValidatorMixin)((0, $47uWi.FlowComponent)) {
    static formAssociated = true;
    #internals;
    static get observedAttributes() {
        return [
            'type',
            'name',
            'placeholder',
            'label',
            'value',
            'disabled',
            'list'
        ];
    }
    constructor(){
        super();
        this.#internals = this.attachInternals();
    }
    static get styles() {
        return 0, $mcP4F.default;
    }
    static get template() {
        return $5896ab0407455938$var$template;
    }
    get disabled() {
        return this.hasAttribute('disabled');
    }
    set disabled(val) {
        if (val) this.setAttribute('disabled', '');
        else this.removeAttribute('disabled');
    }
    onMount() {
        super.onMount(); // Esto ejecuta el onMount del Mixin también
        const input = this.root.querySelector('input');
        const type = this.getAttribute('type') || 'text';
        // Configurar toggle de password si aplica
        if (type === 'password') this.#setupPasswordToggle(input);
        // Asignar dinámicamente el list si existe (para datalist) sin romper los demás inputs
        if (this.hasAttribute('list')) {
            const listId = this.getAttribute('list');
            input.setAttribute('list', listId);
            // Los datalists deben existir en el mismo Shadow DOM que el input para funcionar
            // Buscarlo en el Light DOM (hijos directos) o en el DOM padre (donde vive este componente)
            setTimeout(()=>{
                const dataList = this.querySelector(`datalist#${listId}`) || this.getRootNode().querySelector(`datalist#${listId}`);
                if (dataList && !this.root.querySelector(`datalist#${listId}`)) this.root.appendChild(dataList.cloneNode(true));
            }, 0);
        }
        // Función para sincronizar el estado interno con el form padre
        const syncValidity = ()=>{
            this.setAttribute('value', input.value);
            this.#internals.setFormValue(input.value);
            // Magia: Copiamos el estado de validez del input interno al componente custom
            // Así el formulario padre sabe si este <flow-input> es válido.
            if (!input.checkValidity()) this.#internals.setValidity(input.validity, input.validationMessage, input);
            else this.#internals.setValidity({});
        };
        input.addEventListener('input', syncValidity);
        // Sincronización inicial
        this.#internals.setFormValue(this.getAttribute('value') || '');
    }
    formResetCallback() {
        const initialValue = this.getAttribute('value') || '';
        this.value = initialValue;
        this.#internals.setFormValue(initialValue);
    }
    #setupPasswordToggle(input) {
        const toggleBtn = this.root.querySelector('.password-toggle');
        if (!toggleBtn) return;
        // Mostrar el botón de toggle
        toggleBtn.style.display = 'flex';
        // Agregar padding al input para el icono
        input.style.paddingLeft = '2.5rem';
        let cursorPosition = 0;
        let isMouseDown = false;
        const showPassword = ()=>{
            cursorPosition = input.selectionStart;
            input.type = 'text';
        };
        const hidePassword = ()=>{
            input.type = 'password';
            // Solo restaurar el focus si el input tenía focus antes
            if (document.activeElement === input) input.setSelectionRange(cursorPosition, cursorPosition);
        };
        // Eventos para mouse
        toggleBtn.addEventListener('mousedown', (e)=>{
            e.preventDefault();
            isMouseDown = true;
            showPassword();
        });
        toggleBtn.addEventListener('mouseup', ()=>{
            isMouseDown = false;
            hidePassword();
        });
        // Eventos para touch (mobile)
        toggleBtn.addEventListener('touchstart', (e)=>{
            e.preventDefault();
            showPassword();
        });
        toggleBtn.addEventListener('touchend', ()=>{
            hidePassword();
        });
    }
    get value() {
        return this.root.querySelector('input')?.value || '';
    }
    set value(val) {
        const input = this.root.querySelector('input');
        if (input) {
            input.value = val;
            // Dispatch input event (non-bubbling) to trigger internal listeners (ValidatorMixin and syncValidity)
            input.dispatchEvent(new Event('input', {
                bubbles: false
            }));
        }
        this.setAttribute('value', val);
    }
}
customElements.define('flow-input', $5896ab0407455938$export$21c4e83b6e5ec51);

});
parcelRegister("mcP4F", function(module, exports) {

$parcel$export(module.exports, "default", () => $042c0086928e01c1$export$2e2bcd8739ae039);

var $kaZmj = parcelRequire("kaZmj");
const $042c0086928e01c1$var$sheet = new CSSStyleSheet();
$042c0086928e01c1$var$sheet.replaceSync(`
    :host {
        display: block;
        width: 100%;
    }
`);
var $042c0086928e01c1$export$2e2bcd8739ae039 = [
    (0, $kaZmj.tailwindSheet),
    (0, $kaZmj.baseStyles),
    $042c0086928e01c1$var$sheet
];

});

parcelRegister("2ThBw", function(module, exports) {

$parcel$export(module.exports, "ValidatorMixin", () => $21ae5fa4a0701daa$export$4c457c74a272ec92);

var $gnjKo = parcelRequire("gnjKo");
const $21ae5fa4a0701daa$export$4c457c74a272ec92 = (Base)=>class extends Base {
        // Mapa de estrategias de validación (Regex y Lógica de Negocio)
        #strategies = new Map([
            [
                'email',
                {
                    validate: (val)=>{
                        const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                        if (!regex.test(val)) return false;
                        const domain = val.split('@')[1]?.toLowerCase();
                        const ALLOWED_DOMAINS = new Set([
                            'gmail.com',
                            'outlook.com',
                            'hotmail.com',
                            'icloud.com',
                            'mac.com',
                            'me.com',
                            'qrsmart.click',
                            'qrsmart.menu',
                            'jjco.dev'
                        ]);
                        return ALLOWED_DOMAINS.has(domain);
                    },
                    msg: 'Solo se permiten correos de Gmail, Apple, Microsoft.)'
                }
            ],
            [
                'password',
                {
                    validate: (val)=>{
                        // Developer Experience: Bypass en desarrollo para no sufrir
                        if ((0, $gnjKo.config).isDev) return true;
                        if (val.length < 8) return false;
                        const hasLetter = /[a-zA-Z]/.test(val);
                        const hasNum = /[0-9]/.test(val);
                        return hasLetter && hasNum;
                    },
                    msg: "M\xednimo 8 caracteres, debe incluir letras y n\xfameros"
                }
            ],
            [
                'text',
                {
                    // Solo validación pasiva, la restricción activa se hace en setupConstraints
                    validate: (val)=>val.length <= 125,
                    msg: "M\xe1ximo 125 caracteres"
                }
            ],
            [
                'tel',
                {
                    validate: (val)=>/^[0-9]*$/.test(val) && val.length <= 15,
                    msg: "Solo n\xfameros, m\xe1ximo 15 d\xedgitos"
                }
            ],
            [
                'number',
                {
                    validate: (val)=>/^[0-9]*$/.test(val),
                    msg: "Solo se permiten n\xfameros"
                }
            ]
        ]);
        onMount() {
            super.onMount();
            const input = this.root.querySelector('input');
            const type = this.getAttribute('type') || 'text';
            // 1. Configurar restricciones físicas (Bloqueo de teclas / MaxLength)
            this.#setupConstraints(input, type);
            // 2. Configurar validación en tiempo real
            input.addEventListener('input', ()=>this.#runValidation(input, type));
            // Ejecutar validación inicial si hay valor
            if (input.value) this.#runValidation(input, type);
        }
        #setupConstraints(input, type) {
            // Regla: Texto max 125 chars
            if (type === 'text') input.setAttribute('maxlength', '125');
            // Regla: Tel max 15 chars + Solo números
            if (type === 'tel') {
                input.setAttribute('maxlength', '15');
                this.#blockNonNumeric(input);
            }
            // Regla: Number solo números (Bloqueo estricto, evita 'e', '.', etc si no se desean)
            if (type === 'number') this.#blockNonNumeric(input);
        }
        #blockNonNumeric(input) {
            input.addEventListener('keydown', (e)=>{
                // Permitir teclas de control: Backspace, Tab, Enter, Arrows, Delete, Copy/Paste (Ctrl+C/V)
                const allowedKeys = [
                    'Backspace',
                    'Tab',
                    'Enter',
                    'ArrowLeft',
                    'ArrowRight',
                    'Delete'
                ];
                if (allowedKeys.includes(e.key) || e.ctrlKey || e.metaKey) return;
                // Bloquear si no es número
                if (!/[0-9]/.test(e.key)) e.preventDefault();
            });
        }
        #runValidation(input, type) {
            const strategy = this.#strategies.get(type);
            if (!strategy) return; // Si no hay estrategia, es válido por defecto
            const isValid = strategy.validate(input.value);
            if (!isValid) // Seteamos el error nativo en el input interno
            input.setCustomValidity(strategy.msg);
            else // Limpiamos el error
            input.setCustomValidity('');
            // IMPORTANTE: Disparamos un evento para que la clase base (FlowInput)
            // se entere y actualice ElementInternals si es necesario.
            input.reportValidity();
        }
    };

});


parcelRegister("eXI3l", function(module, exports) {

var $47uWi = parcelRequire("47uWi");

var $f8oil = parcelRequire("f8oil");
const $ae48bf6602e3d56f$var$template = (0, $47uWi.FlowComponent).html`
    <div class="mb-4">
        <label class="block text-sm font-medium text-gray-700 mb-1">${'label'}</label>
        <div class="relative">
            <textarea
                name="${'name'}"
                rows="4"
                maxlength="${'maxlength'}"
                placeholder="${'placeholder'}"
                class="appearance-none rounded-lg relative block w-full px-3 py-3 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm resize-none"
            >${'value'}</textarea>
            <div class="absolute bottom-2 right-2 text-xs text-gray-400 pointer-events-none bg-white/80 px-1 rounded">
                <span id="counter">0</span>/${'maxlength'}
            </div>
        </div>
    </div>
`;
class $ae48bf6602e3d56f$export$a862c33eed8b6c6c extends (0, $47uWi.FlowComponent) {
    static formAssociated = true;
    #internals;
    constructor(){
        super();
        this.#internals = this.attachInternals();
    }
    static get styles() {
        return 0, $f8oil.default;
    }
    static get template() {
        return $ae48bf6602e3d56f$var$template;
    }
    onMount() {
        super.onMount();
        const textarea = this.root.querySelector('textarea');
        const counter = this.root.getElementById('counter');
        const maxLen = this.getAttribute('maxlength') || 175;
        const updateState = ()=>{
            const val = textarea.value;
            this.setAttribute('value', val); // Keep attribute in sync
            this.#internals.setFormValue(val);
            // Update counter
            if (counter) {
                counter.textContent = val.length;
                // Visual warning when close to limit
                if (val.length >= maxLen) counter.parentElement.classList.add('text-red-500', 'font-bold');
                else counter.parentElement.classList.remove('text-red-500', 'font-bold');
            }
            // Sync validity
            if (!textarea.checkValidity()) this.#internals.setValidity(textarea.validity, textarea.validationMessage, textarea);
            else this.#internals.setValidity({});
        };
        textarea.addEventListener('input', updateState);
        // Initial sync
        // If attribute is set but textarea is empty (first render), sync it.
        // If value property was set before mount, textarea should reflect it.
        const initialVal = this.getAttribute('value') || '';
        if (textarea.value !== initialVal) textarea.value = initialVal;
        updateState();
    }
    formResetCallback() {
        const initialValue = this.getAttribute('value') || '';
        this.value = initialValue;
        this.#internals.setFormValue(initialValue);
        // Trigger input event to update counter and validity logic
        const textarea = this.root.querySelector('textarea');
        if (textarea) textarea.dispatchEvent(new Event('input'));
    }
    get value() {
        return this.root.querySelector('textarea')?.value || this.getAttribute('value') || '';
    }
    set value(val) {
        const textarea = this.root.querySelector('textarea');
        if (textarea) {
            textarea.value = val;
            textarea.dispatchEvent(new Event('input')); // Trigger updateState
        } else this.setAttribute('value', val);
    }
}
customElements.define('flow-textarea', $ae48bf6602e3d56f$export$a862c33eed8b6c6c);

});
parcelRegister("f8oil", function(module, exports) {

$parcel$export(module.exports, "default", () => $b04a72d412e163e9$export$2e2bcd8739ae039);

var $kaZmj = parcelRequire("kaZmj");
const $b04a72d412e163e9$var$sheet = new CSSStyleSheet();
$b04a72d412e163e9$var$sheet.replaceSync(`
    :host {
        display: contents;
    }
`);
var $b04a72d412e163e9$export$2e2bcd8739ae039 = [
    (0, $kaZmj.tailwindSheet),
    (0, $kaZmj.baseStyles),
    $b04a72d412e163e9$var$sheet
];

});


parcelRegister("8ODlR", function(module, exports) {

var $47uWi = parcelRequire("47uWi");

var $mcP4F = parcelRequire("mcP4F");

var $2ThBw = parcelRequire("2ThBw");

var $eciFf = parcelRequire("eciFf");
const $66b184a5d2397445$var$template = (0, $47uWi.FlowComponent).html`
    <div class="mb-4">
        <label class="block text-sm font-medium text-graphite-600 mb-1">${'label'}</label>
        <div class="relative">
            <span class="absolute left-3 top-3 text-graphite-400 font-medium select-none">${'symbol'}</span>
            <input
                type="text"
                name="${'name'}"
                placeholder="${'placeholder'}"
                ?disabled="${'disabled'}"
                class="appearance-none rounded-lg block w-full pl-6 pr-3 py-3 border border-graphite-300 placeholder-graphite-400 text-ink-black-500 focus:outline-none focus:ring-2 focus:ring-brilliant-azure-500 focus:border-brilliant-azure-500 sm:text-sm invalid:border-red-500 invalid:text-red-900 focus:invalid:border-red-500 focus:invalid:ring-red-500 disabled:bg-gray-100 disabled:text-gray-500 disabled:cursor-not-allowed"
            >
        </div>
        <!-- Slot opcional para mensajes de error custom si no usamos los nativos -->
        <p class="mt-1 text-sm text-red-600 hidden peer-invalid:block"></p>
    </div>
`;
class $66b184a5d2397445$export$1cc0f99603a61565 extends (0, $2ThBw.ValidatorMixin)((0, $47uWi.FlowComponent)) {
    static formAssociated = true;
    #internals;
    static get observedAttributes() {
        return [
            'label',
            'name',
            'value',
            'placeholder',
            'disabled',
            'required',
            'symbol'
        ];
    }
    constructor(){
        super();
        this.#internals = this.attachInternals();
    }
    static get styles() {
        return 0, $mcP4F.default;
    }
    static get template() {
        return $66b184a5d2397445$var$template;
    }
    onMount() {
        super.onMount();
        if (!this.hasAttribute('symbol')) this.setAttribute('symbol', '$');
        const input = this.root.querySelector('input');
        // 1. Sincronización básica
        const syncValidity = ()=>{
            // Internamente guardamos el valor matemático
            const mathValue = (0, (/*@__PURE__*/$parcel$interopDefault($eciFf)))(input.value).value;
            this.setAttribute('value', mathValue);
            this.#internals.setFormValue(mathValue);
            if (!input.checkValidity()) this.#internals.setValidity(input.validity, input.validationMessage, input);
            else this.#internals.setValidity({});
        };
        // 2. UX: Al enfocar, mostrar el número limpio para fácil edición
        input.addEventListener('focus', ()=>{
            if (input.value) {
                // Si el valor es "0", lo limpiamos para facilitar la escritura
                const val = (0, (/*@__PURE__*/$parcel$interopDefault($eciFf)))(input.value).value;
                input.value = val === 0 ? '' : val;
            }
        });
        // 3. UX: Al salir, formatear bonito
        input.addEventListener('blur', ()=>{
            if (input.value) // Formateamos visualmente ej: 1,250.00
            input.value = (0, (/*@__PURE__*/$parcel$interopDefault($eciFf)))(input.value).format({
                symbol: ''
            });
            syncValidity();
        });
        input.addEventListener('input', syncValidity);
        // Inicializar si hay valor
        const initialVal = this.getAttribute('value');
        if (initialVal) {
            input.value = (0, (/*@__PURE__*/$parcel$interopDefault($eciFf)))(initialVal).format({
                symbol: ''
            });
            this.#internals.setFormValue((0, (/*@__PURE__*/$parcel$interopDefault($eciFf)))(initialVal).value);
        }
    }
    formResetCallback() {
        const initialValue = this.getAttribute('value') || '';
        this.value = initialValue;
        this.#internals.setFormValue(initialValue ? (0, (/*@__PURE__*/$parcel$interopDefault($eciFf)))(initialValue).value : '');
    }
    get value() {
        const rawValue = this.root.querySelector('input')?.value || 0;
        return (0, (/*@__PURE__*/$parcel$interopDefault($eciFf)))(rawValue).value;
    }
    set value(val) {
        const input = this.root.querySelector('input');
        if (input) {
            input.value = val !== null && val !== '' ? (0, (/*@__PURE__*/$parcel$interopDefault($eciFf)))(val).format({
                symbol: ''
            }) : '';
            input.dispatchEvent(new Event('input', {
                bubbles: false
            }));
        }
        this.setAttribute('value', val);
    }
}
customElements.define('flow-price', $66b184a5d2397445$export$1cc0f99603a61565);

});
parcelRegister("eciFf", function(module, exports) {
/*
 currency.js - v2.0.4
 http://scurker.github.io/currency.js

 Copyright (c) 2021 Jason Wilson
 Released under MIT license
*/ (function(e, g) {
    module.exports = g();
})(module.exports, function() {
    function e(b, a) {
        if (!(this instanceof e)) return new e(b, a);
        a = Object.assign({}, m, a);
        var d = Math.pow(10, a.precision);
        this.intValue = b = g(b, a);
        this.value = b / d;
        a.increment = a.increment || 1 / d;
        a.groups = a.useVedic ? n : p;
        this.s = a;
        this.p = d;
    }
    function g(b, a) {
        var d = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : !0;
        var c = a.decimal;
        var h = a.errorOnInvalid, k = a.fromCents, l = Math.pow(10, a.precision), f = b instanceof e;
        if (f && k) return b.intValue;
        if ("number" === typeof b || f) c = f ? b.value : b;
        else if ("string" === typeof b) h = new RegExp("[^-\\d" + c + "]", "g"), c = new RegExp("\\" + c, "g"), c = (c = b.replace(/\((.*)\)/, "-$1").replace(h, "").replace(c, ".")) || 0;
        else {
            if (h) throw Error("Invalid Input");
            c = 0;
        }
        k || (c = (c * l).toFixed(4));
        return d ? Math.round(c) : c;
    }
    var m = {
        symbol: "$",
        separator: ",",
        decimal: ".",
        errorOnInvalid: !1,
        precision: 2,
        pattern: "!#",
        negativePattern: "-!#",
        format: function(b, a) {
            var d = a.pattern, c = a.negativePattern, h = a.symbol, k = a.separator, l = a.decimal;
            a = a.groups;
            var f = ("" + b).replace(/^-/, "").split("."), q = f[0];
            f = f[1];
            return (0 <= b.value ? d : c).replace("!", h).replace("#", q.replace(a, "$1" + k) + (f ? l + f : ""));
        },
        fromCents: !1
    }, p = /(\d)(?=(\d{3})+\b)/g, n = /(\d)(?=(\d\d)+\d\b)/g;
    e.prototype = {
        add: function(b) {
            var a = this.s, d = this.p;
            return e((this.intValue + g(b, a)) / (a.fromCents ? 1 : d), a);
        },
        subtract: function(b) {
            var a = this.s, d = this.p;
            return e((this.intValue - g(b, a)) / (a.fromCents ? 1 : d), a);
        },
        multiply: function(b) {
            var a = this.s;
            return e(this.intValue * b / (a.fromCents ? 1 : Math.pow(10, a.precision)), a);
        },
        divide: function(b) {
            var a = this.s;
            return e(this.intValue / g(b, a, !1), a);
        },
        distribute: function(b) {
            var a = this.intValue, d = this.p, c = this.s, h = [], k = Math[0 <= a ? "floor" : "ceil"](a / b), l = Math.abs(a - k * b);
            for(d = c.fromCents ? 1 : d; 0 !== b; b--){
                var f = e(k / d, c);
                0 < l-- && (f = f[0 <= a ? "add" : "subtract"](1 / d));
                h.push(f);
            }
            return h;
        },
        dollars: function() {
            return ~~this.value;
        },
        cents: function() {
            return ~~(this.intValue % this.p);
        },
        format: function(b) {
            var a = this.s;
            return "function" === typeof b ? b(this, a) : a.format(this, Object.assign({}, a, b));
        },
        toString: function() {
            var b = this.s, a = b.increment;
            return (Math.round(this.intValue / this.p / a) * a).toFixed(b.precision);
        },
        toJSON: function() {
            return this.value;
        }
    };
    return e;
});

});


parcelRegister("b8l7S", function(module, exports) {

$parcel$export(module.exports, "AuthLogin", () => $81b0d43bb7e8c91c$export$ddfe31a7b92780af);

var $47uWi = parcelRequire("47uWi");

var $eOQJ8 = parcelRequire("eOQJ8");

var $aLY8V = parcelRequire("aLY8V");
parcelRequire("3ufjb");
parcelRequire("iVT93");

const $81b0d43bb7e8c91c$var$logo = new URL((parcelRequire("f0tRg")));
const $81b0d43bb7e8c91c$var$template = (0, $47uWi.FlowComponent).html`
    <div class="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
        <div class="max-w-md w-full space-y-8 bg-white p-10 rounded-xl shadow-lg border border-gray-100">
            <div>
                <img class="mx-auto h-16 w-auto" src="${$81b0d43bb7e8c91c$var$logo}" alt="QR Smart Menu">
                <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-900">
                    ${'title'}
                </h2>
                <p class="mt-2 text-center text-sm text-gray-600 mb-8">
                    ${'subtitle'}
                </p>
            </div>
            
            <div id="form-container">
                <slot></slot>
            </div>
        </div>
    </div>
`;
class $81b0d43bb7e8c91c$export$ddfe31a7b92780af extends (0, $aLY8V.AuthLogic)((0, $47uWi.FlowComponent)) {
    #view = 'login';
    static get styles() {
        return 0, $eOQJ8.default;
    }
    static get template() {
        return $81b0d43bb7e8c91c$var$template;
    }
    get view() {
        return this.#view;
    }
    set view(val) {
        if (this.#view === val) return;
        this.#view = val;
        this.#updateContent();
    }
    onMount() {
        super.onMount();
        this.#updateContent();
    }
    #updateContent() {
        // Limpiamos el Light DOM
        this.innerHTML = '';
        switch(this.#view){
            case 'verifying':
                this.setAttribute('title', 'Verificando cuenta');
                this.setAttribute('subtitle', 'Por favor espera un momento...');
                this.innerHTML = '<div class="flex justify-center py-10"><flow-loader></flow-loader></div>';
                break;
            case 'resend-verification':
                this.setAttribute('title', "Verificaci\xf3n necesaria");
                this.setAttribute('subtitle', 'Parece que hubo un problema');
                this.innerHTML = '<resend-verification-form></resend-verification-form>';
                break;
            default:
                this.setAttribute('title', 'Bienvenido de nuevo');
                this.setAttribute('subtitle', 'Ingresa a tu panel administrativo');
                this.innerHTML = '<login-form></login-form>';
        }
    }
}
customElements.define('auth-login', $81b0d43bb7e8c91c$export$ddfe31a7b92780af);

});
parcelRegister("eOQJ8", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac9ea2a99321e948$export$2e2bcd8739ae039);

var $kaZmj = parcelRequire("kaZmj");
const $ac9ea2a99321e948$var$sheet = new CSSStyleSheet();
$ac9ea2a99321e948$var$sheet.replaceSync(`
    :host {
        display: block;
    }
`);
var $ac9ea2a99321e948$export$2e2bcd8739ae039 = [
    (0, $kaZmj.tailwindSheet),
    (0, $kaZmj.baseStyles),
    $ac9ea2a99321e948$var$sheet
];

});

parcelRegister("aLY8V", function(module, exports) {

$parcel$export(module.exports, "AuthLogic", () => $7d7cf24b25425b6a$export$98010628598ae7fc);

var $dkmhp = parcelRequire("dkmhp");

var $djfoQ = parcelRequire("djfoQ");
const $7d7cf24b25425b6a$export$98010628598ae7fc = (Base)=>class extends Base {
        onMount() {
            super.onMount();
            this.root.addEventListener('form:submit', this.#handleLogin.bind(this));
            this.root.addEventListener('form:resend', this.#handleResend.bind(this));
            this.root.addEventListener('view:change', (e)=>{
                this.view = e.detail.view;
            });
            // Verificar token si existe en la URL
            const params = new URLSearchParams(window.location.search);
            const verifyToken = params.get('verify');
            if (verifyToken) this.#handleVerify(verifyToken);
            else this.view = 'login';
        }
        async #handleVerify(token) {
            this.view = 'verifying';
            try {
                const response = await (0, $dkmhp.api).request(`/api/v1/registration/verify/${token}`, {
                    method: 'GET'
                });
                if (response.token) {
                    sessionStorage.setItem('authToken', response.token);
                    (0, $djfoQ.sessionChannel).send({
                        token: response.token,
                        isAuthenticated: true
                    });
                    (0, $djfoQ.notify)("Cuenta verificada con \xe9xito", 'success');
                } else console.error('Token no recibido');
            } catch (error) {
                console.error('[Verification Failed]', error);
                this.view = 'resend-verification';
                (0, $djfoQ.notify)("El enlace ha expirado o no es v\xe1lido", 'error');
            }
        }
        async #handleResend(e) {
            const { action: action, method: method, data: data } = e.detail;
            // Buscamos cuál de los dos formularios emitió el evento
            const form = this.root.querySelector('resend-verification-form') || this.root.querySelector('login-form');
            if (form) form.loading = true;
            try {
                const response = await (0, $dkmhp.api).request(action, {
                    method: method,
                    body: JSON.stringify(data)
                });
                (0, $djfoQ.notify)(response.message || "Verificaci\xf3n enviada", 'success');
                this.view = 'login';
            } catch (error) {
                (0, $djfoQ.notify)(error.message, 'error');
            } finally{
                if (form) form.loading = false;
            }
        }
        async #handleLogin(e) {
            const { action: action, method: method, data: data } = e.detail;
            const form = this.root.querySelector('login-form');
            if (form) form.loading = true;
            try {
                const response = await (0, $dkmhp.api).request(action, {
                    method: method,
                    body: JSON.stringify(data)
                });
                if (response.token) {
                    if (data.rememberMe) localStorage.setItem('authToken', response.token);
                    else sessionStorage.setItem('authToken', response.token);
                    (0, $djfoQ.sessionChannel).send({
                        token: response.token,
                        isAuthenticated: true
                    });
                    (0, $djfoQ.notify)('Login exitoso', 'success');
                } else console.error('Respuesta de servidor incompleta');
            } catch (error) {
                (0, $djfoQ.notify)(error.message, 'error');
                console.error('[Login Failed]', error);
            } finally{
                if (form) form.loading = false;
            }
        }
    };

});

parcelRegister("3ufjb", function(module, exports) {

var $47uWi = parcelRequire("47uWi");

var $eOQJ8 = parcelRequire("eOQJ8");
parcelRequire("7Byou");
parcelRequire("5iwYp");
parcelRequire("k9Ih6");
const $28a00c62d3cffb90$var$template = (0, $47uWi.FlowComponent).html`
    <form action="/api/v1/auth/login" method="POST" class="flex flex-col space-y-4">
        
        <flow-input
            class="order-1"
            label="Correo electrónico"
            type="email"
            name="email"
            placeholder="admin@ejemplo.com"
            required="true">
        </flow-input>

        <flow-input
            id="password-input"
            class="order-2 transition-all duration-300"
            label="Contraseña"
            type="password"
            name="password"
            placeholder="••••••••"
            required="true">
        </flow-input>

        <!-- Botón físicamente aquí para el TAB, pero visualmente al final con order-4 -->
        <flow-button id="submit-btn" type="submit" variant="primary" class="order-4 mt-2 transition-all">
            Iniciar Sesión
        </flow-button>

        <div class="flex items-center justify-between pt-3 pb-2 order-3">
            <div id="remember-me-container" class="transition-all duration-300">
                <flow-checkbox name="remember-me" id="remember-me">
                    Recordarme
                </flow-checkbox>
            </div>

            <div class="text-sm">
                <a href="#" id="toggle-mode-link" class="font-medium text-blue-600 hover:text-blue-500 transition-colors">
                    ¿Olvidaste tu contraseña?
                </a>
            </div>
        </div>
    </form>
`;
class $28a00c62d3cffb90$export$1f58f750f20f344b extends (0, $47uWi.FlowComponent) {
    static get styles() {
        return 0, $eOQJ8.default;
    }
    static get template() {
        return $28a00c62d3cffb90$var$template;
    }
    #mode = 'login';
    set loading(val) {
        const btn = this.root.querySelector('flow-button[type="submit"]');
        if (btn) btn.loading = val;
        const inputs = this.root.querySelectorAll('flow-input');
        inputs.forEach((input)=>{
            // Solo deshabilitamos si está visible (en modo forgot-password el password está oculto)
            if (val) input.setAttribute('disabled', '');
            else input.removeAttribute('disabled');
        });
    }
    onMount() {
        super.onMount();
        const form = this.root.querySelector('form');
        // Manejo nativo del submit
        form.addEventListener('submit', (e)=>{
            e.preventDefault();
            this.#processSubmit(form);
        });
        // Soporte para click en flow-button (si el botón es shadow dom y no propaga submit)
        const submitBtn = this.root.querySelector('flow-button[type="submit"]');
        if (submitBtn) submitBtn.addEventListener('click', ()=>{
            if (form.reportValidity()) form.requestSubmit();
        });
        // Manejo del toggle de vista
        const toggleLink = this.root.getElementById('toggle-mode-link');
        toggleLink?.addEventListener('click', (e)=>{
            e.preventDefault();
            this.#toggleMode();
        });
    }
    #toggleMode() {
        this.#mode = this.#mode === 'login' ? 'forgot-password' : 'login';
        const form = this.root.querySelector('form');
        const passwordInput = this.root.getElementById('password-input');
        const rememberMeContainer = this.root.getElementById('remember-me-container');
        const submitBtn = this.root.getElementById('submit-btn');
        const toggleLink = this.root.getElementById('toggle-mode-link');
        if (this.#mode === 'forgot-password') {
            form.setAttribute('action', '/api/v1/registration/resend-verification');
            passwordInput.style.display = 'none';
            passwordInput.removeAttribute('required');
            passwordInput.value = ''; // Limpiamos la contraseña por seguridad
            rememberMeContainer.style.display = 'none';
            submitBtn.innerHTML = 'Recuperar Password';
            toggleLink.textContent = "Iniciar Sesi\xf3n";
        } else {
            form.setAttribute('action', '/api/v1/auth/login');
            passwordInput.style.display = 'block';
            passwordInput.setAttribute('required', 'true');
            rememberMeContainer.style.display = 'block';
            submitBtn.innerHTML = "Iniciar Sesi\xf3n";
            toggleLink.textContent = "\xbfOlvidaste tu contrase\xf1a?";
        }
    }
    #processSubmit(form) {
        const formData = new FormData(form);
        const data = Object.fromEntries(formData.entries());
        if (this.#mode === 'login') {
            // Asegurar que data.rememberMe tenga un valor booleano correcto
            const rememberMeRaw = data['remember-me'];
            data.rememberMe = rememberMeRaw !== undefined && rememberMeRaw === 'on';
            // Eliminar el campo original para evitar confusión
            if ('remember-me' in data) delete data['remember-me'];
            this.emit('form:submit', {
                data: data,
                action: form.getAttribute('action'),
                method: form.getAttribute('method')
            });
        } else {
            // Modo recuperar password (Solo enviamos el email)
            const payload = {
                email: data.email
            };
            this.emit('form:resend', {
                data: payload,
                action: form.getAttribute('action'),
                method: form.getAttribute('method')
            });
        }
    }
}
customElements.define('login-form', $28a00c62d3cffb90$export$1f58f750f20f344b);

});
parcelRegister("5iwYp", function(module, exports) {

var $47uWi = parcelRequire("47uWi");

var $bB7bE = parcelRequire("bB7bE");
const $3db83606056d54b6$var$template = (0, $47uWi.FlowComponent).html`
    <div class="flex items-center ${'positionClass'}">
        <input
            type="checkbox"
            id="${'id'}"
            name="${'name'}"
            ?disabled="${'disabled'}"
            class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded cursor-pointer disabled:bg-gray-100 disabled:cursor-not-allowed"
        >
        <label for="${'name'}" class="block text-sm text-gray-900 cursor-pointer ${'labelClass'}">
            ${'label'}
            <slot></slot>
        </label>
    </div>
`;
class $3db83606056d54b6$export$9b39b25af1efed83 extends (0, $47uWi.FlowComponent) {
    static formAssociated = true;
    #internals;
    static get observedAttributes() {
        return [
            'checked',
            'label',
            'text-position',
            'name',
            'id',
            'disabled'
        ];
    }
    constructor(){
        super();
        this.#internals = this.attachInternals();
    }
    static get styles() {
        return 0, $bB7bE.default;
    }
    static get template() {
        return $3db83606056d54b6$var$template;
    }
    get checked() {
        return this.root.querySelector('input')?.checked || false;
    }
    set checked(val) {
        const input = this.root.querySelector('input');
        if (input) {
            const isChecked = !!val;
            input.checked = isChecked;
            this.#internals.setFormValue(isChecked ? 'on' : null);
            this.setAttribute('checked', isChecked ? 'true' : 'false');
        }
    }
    get disabled() {
        return this.hasAttribute('disabled');
    }
    set disabled(val) {
        if (val) this.setAttribute('disabled', '');
        else this.removeAttribute('disabled');
    }
    onMount() {
        super.onMount();
        this.#updateLayout();
        const input = this.root.querySelector('input');
        input.onchange = ()=>{
            const isChecked = input.checked;
            this.#internals.setFormValue(isChecked ? 'on' : null);
            this.setAttribute('checked', isChecked ? 'true' : 'false');
            this.dispatchEvent(new CustomEvent('change', {
                detail: {
                    checked: isChecked
                },
                bubbles: true,
                composed: true
            }));
        };
        // Sincronizar estado inicial
        if (this.hasAttribute('checked')) {
            const attrVal = this.getAttribute('checked');
            const isChecked = attrVal === 'true' || attrVal === '';
            input.checked = isChecked;
            this.#internals.setFormValue(isChecked ? 'on' : null);
        }
    }
    onAttributeChanged(name, oldValue, newValue) {
        super.onAttributeChanged(name, oldValue, newValue);
        if (name === 'text-position' && oldValue !== newValue) this.#updateLayout();
        if (name === 'checked' && oldValue !== newValue) {
            const input = this.root.querySelector('input');
            if (input) input.checked = newValue === 'true';
        }
    }
    #updateLayout() {
        const pos = this.getAttribute('text-position') || 'left';
        if (pos === 'left') {
            this.setAttribute('positionClass', 'flex-row-reverse justify-end');
            this.setAttribute('labelClass', 'mr-2');
        } else {
            this.setAttribute('positionClass', 'flex-row');
            this.setAttribute('labelClass', 'ml-2');
        }
    }
}
customElements.define('flow-checkbox', $3db83606056d54b6$export$9b39b25af1efed83);

});
parcelRegister("bB7bE", function(module, exports) {

$parcel$export(module.exports, "default", () => $8718b998e51d02aa$export$2e2bcd8739ae039);

var $kaZmj = parcelRequire("kaZmj");
const $8718b998e51d02aa$var$sheet = new CSSStyleSheet();
$8718b998e51d02aa$var$sheet.replaceSync(`
    :host {
        display: block;
    }
`);
var $8718b998e51d02aa$export$2e2bcd8739ae039 = [
    (0, $kaZmj.tailwindSheet),
    (0, $kaZmj.baseStyles),
    $8718b998e51d02aa$var$sheet
];

});



parcelRegister("iVT93", function(module, exports) {

var $47uWi = parcelRequire("47uWi");

var $eOQJ8 = parcelRequire("eOQJ8");
parcelRequire("gnjKo");
parcelRequire("7Byou");
parcelRequire("k9Ih6");
const $dc8853824058312e$var$template = (0, $47uWi.FlowComponent).html`
    <form action="${'action'}" method="POST" class="space-y-4">
        <p class="text-sm text-gray-600 mb-4">
            El enlace de verificación ha expirado o no es válido. Ingresa tu correo para recibir uno nuevo.
        </p>
        
        <flow-input
            label="Correo electrónico"
            type="email"
            name="email"
            placeholder="tu@correo.com"
            required="true">
        </flow-input>

        <flow-button type="submit" variant="primary">
            Re-enviar Verificación
        </flow-button>

        <div class="text-center pt-2">
            <a href="#" id="back-to-login" class="text-sm font-medium text-blue-600 hover:text-blue-500">
                Volver al inicio de sesión
            </a>
        </div>
    </form>
`;
class $dc8853824058312e$export$4b2bc791dacb8c21 extends (0, $47uWi.FlowComponent) {
    static get styles() {
        return 0, $eOQJ8.default;
    }
    static get template() {
        return $dc8853824058312e$var$template;
    }
    onMount() {
        super.onMount();
        this.action = `/api/v1/registration/resend-verification`;
        const form = this.root.querySelector('form');
        form.addEventListener('submit', (e)=>{
            e.preventDefault();
            this.#processSubmit(form);
        });
        const submitBtn = this.root.querySelector('flow-button[type="submit"]');
        if (submitBtn) submitBtn.addEventListener('click', ()=>{
            if (form.reportValidity()) form.requestSubmit();
        });
        const backLink = this.root.querySelector('#back-to-login');
        if (backLink) backLink.addEventListener('click', (e)=>{
            e.preventDefault();
            this.emit('view:change', {
                view: 'login'
            });
        });
    }
    set loading(val) {
        const btn = this.root.querySelector('flow-button[type="submit"]');
        if (btn) btn.loading = val;
        const input = this.root.querySelector('flow-input');
        if (input) {
            if (val) input.setAttribute('disabled', '');
            else input.removeAttribute('disabled');
        }
    }
    #processSubmit(form) {
        const formData = new FormData(form);
        const data = Object.fromEntries(formData.entries());
        this.emit('form:resend', {
            data: data,
            action: this.action,
            method: 'POST'
        });
    }
}
customElements.define('resend-verification-form', $dc8853824058312e$export$4b2bc791dacb8c21);

});

parcelRegister("f0tRg", function(module, exports) {
module.exports = import.meta.resolve("OZe7s");

});



var $47uWi = parcelRequire("47uWi");

var $kaZmj = parcelRequire("kaZmj");
const $8e95864dbbc4d961$var$sheet = new CSSStyleSheet();
$8e95864dbbc4d961$var$sheet.replaceSync(`
    :host {
        display: block;
        min-height: 100vh;
    }
`);
var $8e95864dbbc4d961$export$2e2bcd8739ae039 = [
    (0, $kaZmj.tailwindSheet),
    (0, $kaZmj.baseStyles),
    $8e95864dbbc4d961$var$sheet
];



var $djfoQ = parcelRequire("djfoQ");

var $dkmhp = parcelRequire("dkmhp");

var $47uWi = parcelRequire("47uWi");

var $kaZmj = parcelRequire("kaZmj");
const $744def1a7e89db9d$var$styles = new CSSStyleSheet();
$744def1a7e89db9d$var$styles.replaceSync(`
    :host {
        display: block;
    }
`);
var $744def1a7e89db9d$export$2e2bcd8739ae039 = [
    (0, $kaZmj.tailwindSheet),
    (0, $kaZmj.baseStyles),
    $744def1a7e89db9d$var$styles
];


const $d71041b05c77e883$var$template = (0, $47uWi.FlowComponent).html`
    <div id="loader-wrapper" class="fixed inset-0 flex items-center justify-center bg-white z-50 transition-opacity duration-300">
        <div class="flex flex-col items-center">
            <!-- Spinner -->
            <svg class="animate-spin h-10 w-10 text-brilliant-azure-500 mb-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            <h2 class="text-gray-600 font-medium text-sm font-roboto" id="loader-message">${'message'}</h2>
        </div>
    </div>
`;
class $d71041b05c77e883$export$2a48b375e67966f8 extends (0, $47uWi.FlowComponent) {
    static get styles() {
        return 0, $744def1a7e89db9d$export$2e2bcd8739ae039;
    }
    static get template() {
        return $d71041b05c77e883$var$template;
    }
    onMount() {
        super.onMount();
        this.#applyVariant();
        // Default message
        const msgEl = this.root.getElementById('loader-message');
        if (msgEl && !this.getAttribute('message')) msgEl.textContent = 'Cargando...';
    }
    #applyVariant() {
        const variant = this.getAttribute('variant');
        const wrapper = this.root.getElementById('loader-wrapper');
        if (variant === 'overlay') {
            wrapper.classList.remove('fixed', 'z-50', 'bg-white');
            wrapper.classList.add('absolute', 'z-20', 'bg-white/70', 'backdrop-blur-[1px]');
        }
    }
}
customElements.define('flow-loading', $d71041b05c77e883$export$2a48b375e67966f8);


parcelRequire("pcvPw");
parcelRequire("7n9n0");
const $812826f9804a18a9$var$template = (0, $47uWi.FlowComponent).html`
    <div id="app-wrapper" class="flex flex-col min-h-screen">
        <div id="global-banners" class="w-full"></div>
        <div id="view-container" class="flex-1 flex flex-col">
            <slot></slot>
        </div>
    </div>
`;




const $812826f9804a18a9$var$VIEW_MAP = new Map([
    [
        'login',
        async ()=>{
            await Promise.resolve((parcelRequire("b8l7S")));
            return document.createElement('auth-login');
        }
    ],
    [
        'dashboard',
        async ()=>{
            await (parcelRequire("9mMsU"));
            return document.createElement('panel-layout');
        }
    ],
    [
        'wizard',
        async ()=>{
            await (parcelRequire("b8DRw"));
            return document.createElement('first-time-wizard');
        }
    ],
    [
        'locked',
        async (data)=>{
            await (parcelRequire("63DoA"));
            const lock = document.createElement('flow-subscription-lock');
            lock.setAttribute('status', data?.status || 'canceled');
            return lock;
        }
    ],
    [
        'loading',
        async (data)=>{
            const loading = document.createElement('flow-loading');
            if (data?.message) loading.setAttribute('message', data.message);
            return loading;
        }
    ]
]);
class $812826f9804a18a9$export$410da74226573775 extends (0, $47uWi.FlowComponent) {
    #currentView = null;
    #isBooting = true;
    static get styles() {
        return 0, $8e95864dbbc4d961$export$2e2bcd8739ae039;
    }
    static get template() {
        return $812826f9804a18a9$var$template;
    }
    onMount() {
        super.onMount();
        const hasToken = !!sessionStorage.getItem('authToken') || !!localStorage.getItem('authToken');
        if (hasToken) this.#navigate('loading', {
            message: "Iniciando sesi\xf3n..."
        });
        this.#initSession();
        (0, $djfoQ.sessionChannel).bind(this, (el, session)=>{
            if (this.#isBooting && hasToken) return;
            if (!session?.isAuthenticated && this.#currentView !== 'login') this.#navigate('login');
            else if (session?.isAuthenticated && !session.subscription && this.#currentView === 'login') this.#initSession();
        });
    }
    async #initSession() {
        const token = sessionStorage.getItem('authToken') || localStorage.getItem('authToken');
        const jwtRegex = /^eyJ[A-Za-z0-9_-]+\.eyJ[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/;
        if (token && jwtRegex.test(token)) {
            if (this.#currentView !== 'loading') this.#navigate('loading', {
                message: 'Verificando cuenta...'
            });
            try {
                const response = await (0, $dkmhp.api).request('/api/v1/subscriptions', {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });
                const { user: user, subscription: subscription } = response.data;
                const status = subscription?.billing?.status || 'active';
                // Primero actualizamos el canal (Helium guardará el estado)
                (0, $djfoQ.sessionChannel).send({
                    user: user,
                    token: token,
                    isAuthenticated: true,
                    subscription: subscription
                });
                // Auto-restore Branch Context if available & permitted
                const storedBranchId = localStorage.getItem('_b');
                if (storedBranchId) {
                    const hasAccess = user.isAccountManager || user.memberships?.some((m)=>m.branchId === storedBranchId);
                    if (hasAccess) (0, $djfoQ.contextChannel).send({
                        branchId: storedBranchId
                    });
                    else localStorage.removeItem('_b'); // Clean up invalid context
                }
                // Luego navegamos y quitamos el modo arranque
                this.#isBooting = false;
                this.#handleAccess(user, status);
            } catch (error) {
                console.error("\u26D4 Error en sesi\xf3n:", error);
                this.#isBooting = false;
                this.#logout();
            }
        } else {
            this.#isBooting = false;
            this.#navigate('login');
        }
        // Escuchamos cuando el wizard termina para refrescar el acceso
        this.addEventListener('wizard-finished', ()=>{
            const session = (0, $djfoQ.sessionChannel).value;
            if (session?.user) {
                session.user.wizardProgress = {
                    ...session.user.wizardProgress,
                    completed: true
                };
                (0, $djfoQ.sessionChannel).send(session); // Actualizamos Helium
                this.#handleAccess(session.user, session.subscription?.billing?.status || 'active');
            }
        });
    }
    #handleAccess(user, status) {
        if (!user?.wizardProgress?.completed) {
            this.#navigate('wizard');
            return;
        }
        const accessMap = {
            active: 'dashboard',
            trial: 'dashboard',
            past_due: 'dashboard'
        };
        this.#navigate(accessMap[status] || 'locked', {
            status: status
        });
    }
    #logout() {
        sessionStorage.clear();
        localStorage.removeItem('authToken');
        localStorage.removeItem('_b');
        (0, $djfoQ.sessionChannel).send({
            user: null,
            token: null,
            isAuthenticated: false,
            subscription: null
        });
        (0, $djfoQ.contextChannel).send({
            branchId: null
        });
        this.#navigate('login');
    }
    async #navigate(view, data = null) {
        if (this.#currentView === view && view !== 'locked') return;
        const loader = $812826f9804a18a9$var$VIEW_MAP.get(view);
        if (!loader) return;
        this.#currentView = view;
        this.innerHTML = '';
        try {
            const component = await loader(data);
            this.appendChild(component);
        } catch (error) {
            console.error(`\u{274C} Error en vista [${view}]:`, error);
        }
    }
}
customElements.define('app-root', $812826f9804a18a9$export$410da74226573775);



var $47uWi = parcelRequire("47uWi");

var $kaZmj = parcelRequire("kaZmj");
const $c41b1cb06e1baee6$var$sheet = new CSSStyleSheet();
$c41b1cb06e1baee6$var$sheet.replaceSync(`
    :host {
        display: block;
        width: 100%;
    }
`);
var $c41b1cb06e1baee6$export$2e2bcd8739ae039 = [
    (0, $kaZmj.tailwindSheet),
    (0, $kaZmj.baseStyles),
    $c41b1cb06e1baee6$var$sheet
];


const $34f4f2adcb862bdb$var$template = (0, $47uWi.FlowComponent).html`
    <form action="${'action'}" method="${'method'}" class="space-y-4">
        <slot></slot>
    </form>
`;
class $34f4f2adcb862bdb$export$8d231fa479317e7d extends (0, $47uWi.FlowComponent) {
    static get styles() {
        return 0, $c41b1cb06e1baee6$export$2e2bcd8739ae039;
    }
    static get template() {
        return $34f4f2adcb862bdb$var$template;
    }
    onMount() {
        super.onMount();
        const form = this.root.querySelector('form');
        // Manejo del submit nativo
        form.onsubmit = (e)=>this.#handleSubmit(e, form);
        // Hack para Shadow DOM:
        // Detectamos si se hizo click en un elemento type="submit" dentro del slot
        // ya que el evento click burbujea desde el Shadow DOM del botón hasta aquí.
        this.root.addEventListener('click', (e)=>{
            // Buscamos si el target original o sus ancestros (dentro del path del evento) es un botón submit
            const path = e.composedPath();
            const submitBtn = path.find((el)=>el.getAttribute && el.getAttribute('type') === 'submit');
            if (submitBtn) // Si encontramos un botón submit, forzamos el envío del formulario
            // Usamos requestSubmit() para que dispare validaciones y el evento submit
            form.requestSubmit();
        });
    }
    #handleSubmit(e, form) {
        e.preventDefault();
        // Recolectamos datos de todos los elementos (nativos y custom con ElementInternals)
        const formData = new FormData(form);
        const data = Object.fromEntries(formData.entries());
        // Emitimos un evento estandarizado
        this.emit('form:submit', {
            data: data,
            action: this.getAttribute('action'),
            method: this.getAttribute('method') || 'POST'
        });
    }
}
customElements.define('flow-form', $34f4f2adcb862bdb$export$8d231fa479317e7d);


parcelRequire("k9Ih6");
parcelRequire("7Byou");
parcelRequire("eXI3l");
parcelRequire("8ODlR");
parcelRequire("5iwYp");

var $47uWi = parcelRequire("47uWi");

var $kaZmj = parcelRequire("kaZmj");
const $2ace1705ec5b6dc2$var$sheet = new CSSStyleSheet();
$2ace1705ec5b6dc2$var$sheet.replaceSync(`
    :host {
        position: fixed;
        top: 1rem;
        right: 1rem;
        z-index: 9999;
        pointer-events: none;
    }
    .toast {
        pointer-events: auto;
        animation: slideIn 0.3s ease-out forwards;
    }
    @keyframes slideIn {
        from { transform: translateX(100%); opacity: 0; }
        to { transform: translateX(0); opacity: 1; }
    }
`);
var $2ace1705ec5b6dc2$export$2e2bcd8739ae039 = [
    (0, $kaZmj.tailwindSheet),
    (0, $kaZmj.baseStyles),
    $2ace1705ec5b6dc2$var$sheet
];



var $djfoQ = parcelRequire("djfoQ");
const $1d9f297392d1cef4$var$template = (0, $47uWi.FlowComponent).html`
    <div id="container" class="space-y-2">
        <!-- Los toasts se inyectarán aquí dinámicamente -->
    </div>
`;
class $1d9f297392d1cef4$export$ea54e2a8fb6d7622 extends (0, $47uWi.FlowComponent) {
    static get styles() {
        return 0, $2ace1705ec5b6dc2$export$2e2bcd8739ae039;
    }
    static get template() {
        return $1d9f297392d1cef4$var$template;
    }
    onMount() {
        super.onMount();
        const container = this.root.querySelector('#container');
        // Nos suscribimos al canal de notificaciones
        (0, $djfoQ.notificationChannel).bind(this.root.host, (el, notification)=>{
            if (!notification) return;
            this.#renderToast(container, notification);
        });
    }
    #renderToast(container, { message: message, type: type, id: id }) {
        const toast = document.createElement('div');
        const bgClass = type === 'error' ? 'bg-red-600' : type === 'success' ? 'bg-green-600' : 'bg-blue-600';
        toast.className = `toast ${bgClass} text-white px-6 py-3 rounded-lg shadow-xl flex items-center justify-between min-w-[300px] mb-2`;
        toast.innerHTML = `
            <span>${message}</span>
            <button class="ml-4 text-white hover:text-gray-200">&times;</button>
        `;
        toast.querySelector('button').onclick = ()=>toast.remove();
        container.appendChild(toast);
        // Auto-remove después de 5 segundos
        setTimeout(()=>{
            if (toast.parentNode) {
                toast.style.opacity = '0';
                toast.style.transform = 'translateX(100%)';
                toast.style.transition = 'all 0.3s ease-in';
                setTimeout(()=>toast.remove(), 300);
            }
        }, 5000);
    }
}
customElements.define('flow-toast', $1d9f297392d1cef4$export$ea54e2a8fb6d7622);



var $47uWi = parcelRequire("47uWi");
var $2152c8f1002d61da$export$2e2bcd8739ae039 = `
    .loader-overlay {
        position: fixed;
        inset: 0;
        background-color: rgba(17, 24, 39, 0.7); /* Gris oscuro (Tailwind gray-900) con 70% de opacidad */
        backdrop-filter: blur(6px);
        -webkit-backdrop-filter: blur(6px);
        z-index: 9998; /* Justo debajo de los Toasts (9999) */
        display: none;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    
    .loader-overlay.active {
        display: flex;
    }

    .sk-cube-grid {
        width: 60px;
        height: 60px;
        margin: 0 auto;
    }

    .sk-cube-grid .sk-cube {
        width: 33%;
        height: 33%;
        float: left;
        -webkit-animation: sk-cubeGridScaleDelay 1.3s infinite ease-in-out;
        animation: sk-cubeGridScaleDelay 1.3s infinite ease-in-out;
    }
    .sk-cube-grid .sk-cube1 {
        -webkit-animation-delay: 0.2s;
        animation-delay: 0.2s; }
    .sk-cube-grid .sk-cube2 {
        -webkit-animation-delay: 0.3s;
        animation-delay: 0.3s; }
    .sk-cube-grid .sk-cube3 {
        -webkit-animation-delay: 0.4s;
        animation-delay: 0.4s; }
    .sk-cube-grid .sk-cube4 {
        -webkit-animation-delay: 0.1s;
        animation-delay: 0.1s; }
    .sk-cube-grid .sk-cube5 {
        -webkit-animation-delay: 0.2s;
        animation-delay: 0.2s; }
    .sk-cube-grid .sk-cube6 {
        -webkit-animation-delay: 0.3s;
        animation-delay: 0.3s; }
    .sk-cube-grid .sk-cube7 {
        -webkit-animation-delay: 0s;
        animation-delay: 0s; }
    .sk-cube-grid .sk-cube8 {
        -webkit-animation-delay: 0.1s;
        animation-delay: 0.1s; }
    .sk-cube-grid .sk-cube9 {
        -webkit-animation-delay: 0.2s;
        animation-delay: 0.2s; }

    @-webkit-keyframes sk-cubeGridScaleDelay {
        0%, 70%, 100% {
            -webkit-transform: scale3D(1, 1, 1);
            transform: scale3D(1, 1, 1);
        } 35% {
              -webkit-transform: scale3D(0, 0, 1);
              transform: scale3D(0, 0, 1);
          }
    }

    @keyframes sk-cubeGridScaleDelay {
        0%, 70%, 100% {
            -webkit-transform: scale3D(1, 1, 1);
            transform: scale3D(1, 1, 1);
        } 35% {
              -webkit-transform: scale3D(0, 0, 1);
              transform: scale3D(0, 0, 1);
          }
    }
`;



var $kaZmj = parcelRequire("kaZmj");

var $djfoQ = parcelRequire("djfoQ");
const $0308dc40fddbc8fd$var$template = (0, $47uWi.FlowComponent).html`
    <div id="loader-overlay" class="loader-overlay">
        <div class="sk-cube-grid">
            <div class="sk-cube sk-cube1 bg-brilliant-azure-500"></div>
            <div class="sk-cube sk-cube2 bg-brilliant-azure-500"></div>
            <div class="sk-cube sk-cube3 bg-brilliant-azure-500"></div>
            <div class="sk-cube sk-cube4 bg-brilliant-azure-500"></div>
            <div class="sk-cube sk-cube5 bg-brilliant-azure-500"></div>
            <div class="sk-cube sk-cube6 bg-brilliant-azure-500"></div>
            <div class="sk-cube sk-cube7 bg-brilliant-azure-500"></div>
            <div class="sk-cube sk-cube8 bg-brilliant-azure-500"></div>
            <div class="sk-cube sk-cube9 bg-brilliant-azure-500"></div>
        </div>
        <p id="loader-message" class="text-white text-lg font-medium mt-6 tracking-wide drop-shadow-md">${'loaderMessage'}</p>
    </div>
`;
class $0308dc40fddbc8fd$export$46ccebee5de9896a extends (0, $47uWi.FlowComponent) {
    static get styles() {
        return [
            (0, $kaZmj.tailwindSheet),
            (0, $kaZmj.baseStyles),
            (0, $2152c8f1002d61da$export$2e2bcd8739ae039)
        ];
    }
    static get template() {
        return $0308dc40fddbc8fd$var$template;
    }
    onMount() {
        super.onMount();
        const overlay = this.root.getElementById('loader-overlay');
        // Nos suscribimos al canal de UI para escuchar el estado del loader
        (0, $djfoQ.uiChannel).bind(this, (el, state)=>{
            if (state.isLoading) {
                overlay.classList.add('active');
                // Sincronizamos el mensaje
                this.setAttribute('loaderMessage', state.loaderMessage || 'Cargando...');
            } else overlay.classList.remove('active');
        });
    }
}
customElements.define('flow-loader', $0308dc40fddbc8fd$export$46ccebee5de9896a);



var $47uWi = parcelRequire("47uWi");

var $kaZmj = parcelRequire("kaZmj");
const $ae4f0cb2a937716b$var$template = (0, $47uWi.FlowComponent).html`
    <h1 class="text-4xl font-bold p-10">Hola</h1>
`;
class $ae4f0cb2a937716b$export$6d57d43d8e83ab83 extends (0, $47uWi.FlowComponent) {
    static get styles() {
        return [
            (0, $kaZmj.tailwindSheet),
            (0, $kaZmj.baseStyles)
        ];
    }
    static get template() {
        return $ae4f0cb2a937716b$var$template;
    }
}
customElements.define('flow-panel', $ae4f0cb2a937716b$export$6d57d43d8e83ab83);


parcelRequire("b8l7S");
// En el futuro aquí podríamos inicializar configuraciones globales o temas
// TODO: Branch service: Detectar hubo cambios en logo, si no hubo edicion no volver a subirlo
console.info("1.0.0");


//# sourceMappingURL=panel.53617ea1.js.map
